// import React, { useState, useRef, useMemo, useEffect } from "react";
// import { Box, Button, Container, Typography, Snackbar, Alert, CircularProgress, LinearProgress, Card, CardContent, Grid, TextField, InputAdornment, Paper, Divider, Stack, IconButton, Collapse, alpha, Chip, Tooltip, useMediaQuery, useTheme } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import * as XLSX from "xlsx";
// import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
// import SearchIcon from '@mui/icons-material/Search';
// import BusinessIcon from '@mui/icons-material/Business';
// import PhoneIcon from '@mui/icons-material/Phone';
// import EmailIcon from '@mui/icons-material/Email';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import WarningIcon from '@mui/icons-material/Warning';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import ExpandLessIcon from '@mui/icons-material/ExpandLess';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import ErrorIcon from '@mui/icons-material/Error';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import { useAuth } from '../context/AuthContext';

// // Simple UUID-like ID generator for unique row IDs
// const generateUniqueId = () => {
//     return `row-${Math.random().toString(36).substr(2, 9)}-${Date.now().toString(36)}`;
// };

// // Modern Glass Card with enhanced styling
// const GlassParentCard = ({ children }) => (
//     <Paper
//         elevation={0}
//         sx={{
//             borderRadius: { xs: 2, sm: 3, md: 4 },
//             background: (theme) => `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.95)} 0%, ${alpha(theme.palette.background.paper, 0.85)} 100%)`,
//             backdropFilter: "blur(20px)",
//             WebKitBackdropFilter: "blur(20px)",
//             border: `1px solid ${(theme) => alpha(theme.palette.primary.main, 0.1)}`,
//             [`& .MuiPaper-root`]: { borderRadius: { xs: 2, sm: 3 } },
//             boxShadow: "0 20px 60px rgba(25, 118, 210, 0.08), 0 0 1px rgba(25, 118, 210, 0.1)",
//             position: "relative",
//             overflow: "hidden",
//             maxHeight: { xs: "calc(100vh - 300px)", sm: "calc(100vh - 250px)", md: "78vh" },
//             display: "flex",
//             flexDirection: "column",
//             "&::before": {
//                 content: '""',
//                 position: "absolute",
//                 top: 0,
//                 left: 0,
//                 right: 0,
//                 height: 1,
//                 background: `linear-gradient(90deg, transparent, rgba(25, 118, 210, 0.3), transparent)`,
//             },
//             "&::after": {
//                 content: '""',
//                 position: "absolute",
//                 top: 0,
//                 left: 0,
//                 width: 4,
//                 height: "100%",
//                 background: "linear-gradient(180deg, #1976d2, #42a5f5, transparent)",
//                 borderRadius: "0 8px 8px 0",
//             }
//         }}
//     >
//         {children}
//     </Paper>
// );

// // Enhanced File Upload Zone
// const FileUploadZone = ({ fileInputRef, file, handleFileChange, data }) => {
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//     const [isDragOver, setIsDragOver] = useState(false);

//     const handleDragOver = (e) => {
//         e.preventDefault();
//         setIsDragOver(true);
//     };

//     const handleDragLeave = () => {
//         setIsDragOver(false);
//     };

//     const handleDrop = (e) => {
//         e.preventDefault();
//         setIsDragOver(false);
//         const droppedFiles = e.dataTransfer.files;
//         if (droppedFiles.length > 0) {
//             fileInputRef.current.files = droppedFiles;
//             const event = new Event('change', { bubbles: true });
//             Object.defineProperty(event, 'target', { value: fileInputRef.current, enumerable: true });
//             handleFileChange(event);
//         }
//     };

//     return (
//         <Box
//             onDragOver={handleDragOver}
//             onDragLeave={handleDragLeave}
//             onDrop={handleDrop}
//             sx={{
//                 position: "relative",
//                 borderRadius: { xs: 2, sm: 3 },
//                 border: `2px dashed ${isDragOver ? '#1976d2' : alpha('#1976d2', 0.3)}`,
//                 p: { xs: 2, sm: 3 },
//                 textAlign: "center",
//                 transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//                 background: isDragOver ? alpha('#1976d2', 0.05) : alpha('#1976d2', 0.02),
//                 cursor: "pointer",
//                 "&:hover": {
//                     borderColor: '#1976d2',
//                     bgcolor: alpha('#1976d2', 0.04),
//                 },
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 minHeight: { xs: 120, sm: 140 },
//                 gap: 2,
//             }}
//         >
//             <input type="file" accept=".xlsx,.xls,.csv" onChange={handleFileChange} ref={fileInputRef} style={{ display: "none" }} id="file-upload" />

//             <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
//                 <CloudUploadIcon sx={{ fontSize: { xs: 40, sm: 50 }, color: '#1976d2', opacity: 0.7 }} />
//                 <Box>
//                     <Typography
//                         variant="body1"
//                         sx={{
//                             fontWeight: 600,
//                             color: "#1976d2",
//                             fontSize: { xs: "0.95rem", sm: "1.1rem" },
//                             mb: 0.5
//                         }}
//                     >
//                         {file ? `Selected: ${file.name}` : "Drop your file here or click to browse"}
//                     </Typography>
//                     <Typography
//                         variant="caption"
//                         sx={{
//                             color: "text.secondary",
//                             fontSize: { xs: "0.75rem", sm: "0.875rem" }
//                         }}
//                     >
//                         Excel (.xlsx, .xls) or CSV files only
//                     </Typography>
//                 </Box>
//             </Box>

//             <Button
//                 variant="contained"
//                 onClick={(e) => {
//                     e.stopPropagation();
//                     const hasError = data.some(r => r._missingFields?.length > 0);
//                     if (data.length > 0 && hasError && !window.confirm("There are rows with errors. Are you sure you want to choose a new file?")) {
//                         return;
//                     }
//                     fileInputRef.current.click();
//                 }}
//                 sx={{
//                     height: { xs: 36, sm: 40 },
//                     bgcolor: "#1976d2",
//                     "&:hover": { bgcolor: "#115293" },
//                     borderRadius: 1.5,
//                     textTransform: "none",
//                     fontWeight: 600,
//                     px: { xs: 2, sm: 2.5 },
//                     whiteSpace: "nowrap",
//                     fontSize: { xs: "0.85rem", sm: "0.95rem" },
//                     boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
//                     transition: "all 0.3s ease",
//                     "&:hover": {
//                         bgcolor: "#115293",
//                         boxShadow: "0 6px 16px rgba(25, 118, 210, 0.4)",
//                         transform: "translateY(-2px)"
//                     }
//                 }}
//             >
//                 Browse
//             </Button>
//         </Box>
//     );
// };

// const InsertClient = ({ connectionString }) => {
//     const { user, selectedCompany, loading } = useAuth();
//     const path = connectionString;
//     const navigate = useNavigate();
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//     const isTablet = useMediaQuery(theme.breakpoints.down('md'));
//     const fileInputRef = useRef(null);
//     const [file, setFile] = useState(null);
//     const [data, setData] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [uploading, setUploading] = useState(false);
//     const [uploadProgress, setUploadProgress] = useState(0);
//     const [progressValue, setProgressValue] = useState(0);
//     const [bufferValue, setBufferValue] = useState(0);
//     const [showBuffer, setShowBuffer] = useState(false);
//     const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
//     const [searchText, setSearchText] = useState("");
//     const [expandedCards, setExpandedCards] = useState({});
//     const [filterMode, setFilterMode] = useState('all');
//     const [clientCategory, setClientCategory] = useState("");
//     const [insertedIds, setInsertedIds] = useState(new Set());
//     const [fadeOutIds, setFadeOutIds] = useState(new Set());
//     const [rowStatus, setRowStatus] = useState({});

//     const toggleExpand = (id) => setExpandedCards(prev => ({ ...prev, [id]: !prev[id] }));
//     const clientCategoryOptions = [{ display: "Bank Receipt", value: "Br" }, { display: "Cash Receipt", value: "Cr" }];

//     console.log("InsertClient props:", { user, selectedCompany, connectionString });

//     const companyId = selectedCompany?.CompId || null;
//     const fYear = getCurrentFYear();
//     const userId = user?.UserId || null;

//     const updateProgress = (value) => {
//         const clipped = Math.max(0, Math.min(100, value));
//         setProgressValue(clipped);
//         setBufferValue(Math.min(100, clipped + 10));
//     };

//     // Helper to check if a field has an error
//     const hasFieldError = (record, fieldKey) => {
//         if (!record._missingFields) return false;
//         const fieldMap = {
//             GSTNo: "GST No.",
//             CompanyName: "Company Name",
//             ClientCategory: "Client Category",
//             ClientCode: "Client Code",
//             Address: "Address",
//             Area: "Landmark",
//             PinCode: "Pincode",
//             City: "City",
//             State: "State",
//             StateCode: "State Code",
//             Country: "Country",
//             Distance: "Distance",
//             ContactPerson: "Contact Person",
//             MobileNo: "Mobile No.",
//             AlternateMobile: "Alt Mobile",
//             EmailId: "Email Id",
//             AlternateEmailId: "Alternate Email",
//             Website: "Website",
//             PANNo: "PAN No.",
//             AadharNo: "Aadhar No.",
//             MSMENo: "MSME No.",
//             Transporter: "Transporter",
//             AgentName: "Agent Name",
//             AgentComm: "Agent Comm (%)",
//             PaymentTerms: "Payment Days",
//             CreditLimit: "Credit Limit",
//             Interest: "Interest (%)",
//             Disc: "Discount (%)"
//         };
//         const errorLabel = fieldMap[fieldKey];
//         return errorLabel ? record._missingFields.some(err => err.includes(errorLabel)) : false;
//     };

//     useEffect(() => {
//         const hasRedError = data.some(r => r._missingFields?.length > 0);
//         const handleBeforeUnload = (e) => {
//             if (hasRedError && data.length > 0) {
//                 e.preventDefault();
//                 e.returnValue = '';
//             }
//         };
//         window.addEventListener('beforeunload', handleBeforeUnload);
//         return () => window.removeEventListener('beforeunload', handleBeforeUnload);
//     }, [data]);

//     const handleFileChange = (e) => {
//         const selectedFile = e.target.files[0];
//         if (selectedFile) {
//             const validExtensions = [".xlsx", ".xls", ".csv"];
//             const fileExtension = selectedFile.name.slice(selectedFile.name.lastIndexOf(".")).toLowerCase();
//             if (!validExtensions.includes(fileExtension)) {
//                 setSnackbar({ open: true, message: "Only Excel (.xlsx, .xls) or CSV (.csv) files are allowed", severity: "error" });
//                 setFile(null);
//                 setData([]);
//                 setFilteredData([]);
//                 fileInputRef.current.value = "";
//                 return;
//             }

//             setFile(selectedFile);
//             fileInputRef.current.value = null;

//             // Reset all states
//             setData([]);
//             setFilteredData([]);
//             setRowStatus({});
//             setFadeOutIds(new Set());
//             setShowBuffer(true);
//             setFilterMode('all');
//             updateProgress(3);

//             // Clone file to force fresh read
//             const clonedFile = new File([selectedFile], selectedFile.name, { type: selectedFile.type });
//             processFile(clonedFile);
//         }
//     };

//     const processFile = (file) => {
//         const reader = new FileReader();

//         reader.onprogress = (e) => {
//             if (e.lengthComputable) {
//                 const percentRead = Math.round((e.loaded / e.total) * 100);
//                 const mapped = Math.round(percentRead * 0.5);
//                 updateProgress(mapped);
//             }
//         };

//         reader.onload = (e) => {
//             try {
//                 const binaryData = e.target.result;
//                 const workbook = XLSX.read(binaryData, { type: "binary" });
//                 const sheetName = workbook.SheetNames[0];
//                 const sheet = workbook.Sheets[sheetName];
//                 const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

//                 const expectedHeaders = [
//                     "GSTNo", "CompanyName", "ClientCategory", "ClientCode", "Address", "Landmark", "Pincode",
//                     "City", "State", "StateCode", "Country", "Distance",
//                     "ContactPerson", "MobileNo", "AlternateMobileNo", "EmailId", "AlternateEmailId",
//                     "Website", "PANNo", "AadharNo", "MSMENo", "Transporter", "AgentName",
//                     "AgentCommission", "PaymentDays", "CreditLimit", "Interest", "Disc"
//                 ];

//                 const headers = jsonData[0] || [];
//                 const headersValid = expectedHeaders.every((header, index) => header === headers[index]);

//                 if (!headersValid) {
//                     setSnackbar({ open: true, message: "Invalid file format. Expected headers: " + expectedHeaders.join(", "), severity: "error" });
//                     setData([]);
//                     setFilteredData([]);
//                     updateProgress(0);
//                     setShowBuffer(false);
//                     return;
//                 }

//                 const requiredFields = [
//                     { key: 'CompanyName', label: 'Company Name' },
//                     { key: 'City', label: 'City' },
//                     { key: 'State', label: 'State' },
//                     { key: 'StateCode', label: 'State Code' },
//                     { key: 'Country', label: 'Country' },
//                     { key: 'ContactPerson', label: 'Contact Person' },
//                     { key: 'MobileNo', label: 'Mobile No.' },
//                     { key: 'EmailId', label: 'Email Id' }
//                 ];

//                 const parsedData = jsonData.slice(1).map((row) => {
//                     const record = {
//                         id: generateUniqueId(),
//                         GSTNo: row[0] || "",
//                         CompanyName: row[1] || "",
//                         ClientCategory: row[2] || "",
//                         ClientCode: row[3] || "",
//                         Address: row[4] || "",
//                         Area: row[5] || "",
//                         PinCode: row[6] || "",
//                         City: row[7] || "",
//                         State: row[8] || "",
//                         StateCode: row[9] || "",
//                         Country: row[10] || "",
//                         Distance: row[11] || "",
//                         ContactPerson: row[12] || "",
//                         MobileNo: row[13] || "",
//                         AlternateMobile: row[14] || "",
//                         EmailId: row[15] || "",
//                         AlternateEmailId: row[16] || "",
//                         Website: row[17] || "",
//                         PANNo: row[18] || "",
//                         AadharNo: row[19] || "",
//                         MSMENo: row[20] || "",
//                         Transporter: row[21] || "",
//                         AgentName: row[22] || "",
//                         AgentComm: row[23] || "",
//                         PaymentTerms: row[24] || "",
//                         CreditLimit: row[25] || "",
//                         Interest: row[26] || "",
//                         Disc: row[27] || ""
//                     };

//                     const missing = requiredFields
//                         .filter(f => !record[f.key] || String(record[f.key]).trim() === '')
//                         .map(f => f.label);

//                     const validationErrors = [];

//                     if (record.GSTNo && record.GSTNo.trim().length !== 15) {
//                         validationErrors.push("GST No. must be 15 characters");
//                     }

//                     const pincodeStr = record.PinCode?.toString().trim();
//                     if (pincodeStr && (!/^\d{6}$/.test(pincodeStr))) {
//                         validationErrors.push("Pincode must be 6 digits");
//                     }

//                     const mobileStr = record.MobileNo?.toString().trim();
//                     if (mobileStr && !/^\d{10}$/.test(mobileStr)) {
//                         validationErrors.push("Mobile No. must be 10 digits");
//                     }

//                     const altMobileStr = record.AlternateMobile?.toString().trim();
//                     if (altMobileStr && !/^\d{10}$/.test(altMobileStr)) {
//                         validationErrors.push("Alt Mobile must be 10 digits");
//                     }

//                     const aadharStr = record.AadharNo?.toString().trim();
//                     if (aadharStr && !/^\d{12}$/.test(aadharStr)) {
//                         validationErrors.push("Aadhar No. must be 12 digits");
//                     }

//                     record._missingFields = [...missing, ...validationErrors];

//                     return record;
//                 }).filter(row =>
//                     row.CompanyName || row.ContactPerson || row.MobileNo || row.EmailId
//                 );

//                 setData(parsedData);
//                 setFilteredData(parsedData);
//                 setInsertedIds(new Set());
//                 setFadeOutIds(new Set());
//                 setRowStatus({});

//                 updateProgress(50);
//                 setSnackbar({ open: true, message: `Successfully parsed ${parsedData.length} records`, severity: "success" });

//                 updateProgress(100);
//                 setTimeout(() => {
//                     setShowBuffer(false);
//                     updateProgress(0);
//                 }, 800);
//             } catch (err) {
//                 console.error(err);
//                 setSnackbar({ open: true, message: "Error parsing file", severity: "error" });
//                 setData([]);
//                 setFilteredData([]);
//                 updateProgress(0);
//                 setShowBuffer(false);
//             }
//         };

//         reader.onerror = () => {
//             setSnackbar({ open: true, message: "Error reading file", severity: "error" });
//             setData([]);
//             setFilteredData([]);
//             updateProgress(0);
//             setShowBuffer(false);
//         };

//         reader.readAsBinaryString(file);
//     };

//     const handleUploadSubmit = async () => {
//         if (!data.length) {
//             setSnackbar({ open: true, message: "No data to upload", severity: "error" });
//             return;
//         }

//         const validRows = data.filter(r => !r._missingFields || r._missingFields.length === 0);
//         const errorRows = data.filter(r => r._missingFields?.length > 0);

//         if (validRows.length === 0) {
//             setSnackbar({ open: true, message: "All rows contain errors – nothing to insert", severity: "error" });
//             return;
//         }

//         if (!companyId || !userId) {
//             setSnackbar({ open: true, message: "Missing company/user data", severity: "error" });
//             return;
//         }

//         setUploading(true);
//         setShowBuffer(true);
//         updateProgress(0);

//         let insertedCount = 0;
//         let existsCount = 0;
//         let failedCount = 0;
//         const clientCategoryValue = clientCategoryOptions.find(option => option.display === clientCategory)?.value || "";

//         const insertedRowIds = [];

//         try {
//             for (let i = 0; i < validRows.length; i++) {
//                 const row = validRows[i];

//                 const payload = {
//                     gstNo: row.GSTNo,
//                     companyName: row.CompanyName,
//                     clientCode: row.ClientCode,
//                     clientCategory: clientCategoryValue,
//                     address: row.Address,
//                     area: row.Area,
//                     pinCode: row.PinCode,
//                     city: row.City,
//                     state: row.State,
//                     stateCode: row.StateCode,
//                     country: row.Country,
//                     distance: row.Distance === "" ? 0 : parseFloat(row.Distance),
//                     contactPerson: row.ContactPerson,
//                     mobileNo: row.MobileNo,
//                     alternateMobile: row.AlternateMobiles,
//                     emailId: row.EmailId,
//                     alternateEmailId: row.AlternateEmailId,
//                     website: row.Website,
//                     panNo: row.PANNo,
//                     aadharNo: row.AadharNo,
//                     transporter: row.Transporter,
//                     agentName: row.AgentName,
//                     agentComm: row.AgentComm === "" ? 0 : parseFloat(row.AgentComm),
//                     msmeNo: row.MSMENo,
//                     paymentTerms: row.PaymentTerms === "" ? 0 : parseInt(row.PaymentTerms),
//                     creditLimit: row.CreditLimit === "" ? 0 : parseFloat(row.CreditLimit),
//                     interest: row.Interest === "" ? 0 : parseFloat(row.Interest),
//                     disc: row.Disc === "" ? 0 : parseFloat(row.Disc),
//                     companyId,
//                     fYear,
//                     userId
//                 };

//                 try {
//                     const response = await axios.post(`${path}/client/insert`, payload, {
//                         validateStatus: (status) => [200, 201, 204, 304, 500].includes(status)
//                     });

//                     const status = response.status;
//                     let message = "";

//                     if (status === 201) {
//                         message = "Inserted";
//                         insertedCount++;
//                         insertedRowIds.push(row.id);
//                     } else if (status === 204 || status === 304) {
//                         message = "Already Exists";
//                         existsCount++;
//                     } else {
//                         message = "Failed";
//                         failedCount++;
//                     }

//                     setRowStatus(prev => ({
//                         ...prev,
//                         [row.id]: { status, message }
//                     }));
//                 } catch (err) {
//                     const status = err.response?.status || 500;
//                     setRowStatus(prev => ({
//                         ...prev,
//                         [row.id]: { status, message: "Failed" }
//                     }));
//                     failedCount++;
//                 }

//                 const progress = 50 + Math.round(((i + 1) / validRows.length) * 50);
//                 updateProgress(progress);
//             }

//             const parts = [];
//             if (insertedCount) parts.push(`${insertedCount} Inserted`);
//             if (existsCount) parts.push(`${existsCount} Already Exists`);
//             if (failedCount) parts.push(`${failedCount} Failed`);
//             if (errorRows.length) parts.push(`${errorRows.length} Skipped (errors)`);

//             setSnackbar({
//                 open: true,
//                 message: parts.join(" | "),
//                 severity: insertedCount > 0 ? "success" : "warning"
//             });

//             setTimeout(() => {
//                 const sortedFadeIds = insertedRowIds
//                     .map(id => ({ id, name: data.find(r => r.id === id)?.CompanyName || "" }))
//                     .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
//                     .map(item => item.id);

//                 sortedFadeIds.forEach((id, index) => {
//                     setTimeout(() => {
//                         setFadeOutIds(prev => new Set(prev).add(id));
//                     }, index * 1000);
//                 });

//                 setTimeout(() => {
//                     setData(prev => prev.filter(r => !insertedRowIds.includes(r.id)));
//                     setInsertedIds(new Set());
//                     setFadeOutIds(new Set());
//                     setRowStatus({});
//                 }, sortedFadeIds.length * 1000 + 600);
//             }, 5000);

//         } catch (error) {
//             console.error("Unexpected error:", error);
//             setSnackbar({ open: true, message: "Unexpected error occurred", severity: "error" });
//         } finally {
//             setUploading(false);
//             setShowBuffer(false);
//         }
//     };

//     const handleBackClick = () => { navigate("/main/newClient"); };

//     const sortedData = useMemo(() => {
//         const withError = data.filter(r => (r._missingFields?.length || 0) > 0);
//         const withoutError = data.filter(r => !r._missingFields || r._missingFields.length === 0);

//         const sortedWithoutError = [...withoutError].sort((a, b) => {
//             const nameA = (a.CompanyName || "").trim().toLowerCase();
//             const nameB = (b.CompanyName || "").trim().toLowerCase();
//             return nameA.localeCompare(nameB);
//         });

//         return [...withError, ...sortedWithoutError];
//     }, [data]);

//     const filteredDataFinal = useMemo(() => {
//         let result = sortedData;

//         if (filterMode === 'perfect') {
//             result = result.filter(r => !r._missingFields || r._missingFields.length === 0);
//         } else if (filterMode === 'error') {
//             result = result.filter(r => r._missingFields?.length > 0);
//         }

//         if (searchText.trim()) {
//             const lowerSearch = searchText.toLowerCase();
//             result = result.filter(row =>
//                 row.CompanyName?.toLowerCase().includes(lowerSearch) ||
//                 String(row.GSTNo).toLowerCase().includes(lowerSearch) ||
//                 String(row.MobileNo).toLowerCase().includes(lowerSearch) ||
//                 String(row.EmailId).toLowerCase().includes(lowerSearch)
//             );
//         }

//         return result;
//     }, [sortedData, filterMode, searchText]);

//     useMemo(() => {
//         setFilteredData(filteredDataFinal);
//     }, [filteredDataFinal]);

//     const errorCount = useMemo(() => data.filter(r => r._missingFields?.length > 0).length, [data]);
//     const perfectCount = useMemo(() => data.length - errorCount, [data]);
//     const validRowsCount = useMemo(() => data.filter(r => !r._missingFields || r._missingFields.length === 0).length, [data]);

//     const fieldGroups = [
//         {
//             title: "Company Info",
//             icon: <BusinessIcon fontSize="small" />,
//             fields: [
//                 { label: "GST No.", key: "GSTNo" },
//                 { label: "Company Name", key: "CompanyName" },
//                 { label: "Client Category", key: "ClientCategory" },
//                 { label: "Client Code", key: "ClientCode" },
//                 { label: "Contact Person", key: "ContactPerson" },
//                 { label: "Mobile No.", key: "MobileNo" },
//                 { label: "Email Id", key: "EmailId" },
//             ]
//         },
//         {
//             title: "Address",
//             icon: <LocationOnIcon fontSize="small" />,
//             fields: [
//                 { label: "Address", key: "Address" },
//                 { label: "Landmark", key: "Area" },
//                 { label: "City", key: "City" },
//                 { label: "State", key: "State" },
//                 { label: "Pincode", key: "PinCode" },
//                 { label: "Country", key: "Country" },
//             ]
//         },
//         {
//             title: "Financial & Agent",
//             icon: <PhoneIcon fontSize="small" />,
//             fields: [
//                 { label: "Agent Name", key: "AgentName" },
//                 { label: "Agent Comm (%)", key: "AgentComm" },
//                 { label: "Payment Days", key: "PaymentTerms" },
//                 { label: "Credit Limit", key: "CreditLimit" },
//                 { label: "Interest (%)", key: "Interest" },
//                 { label: "Discount (%)", key: "Disc" },
//             ]
//         },
//         {
//             title: "Other Details",
//             icon: <EmailIcon fontSize="small" />,
//             fields: [
//                 { label: "Alternate Mobile", key: "AlternateMobile" },
//                 { label: "Alternate Email", key: "AlternateEmailId" },
//                 { label: "Website", key: "Website" },
//                 { label: "PAN No.", key: "PANNo" },
//                 { label: "Aadhar No.", key: "AadharNo" },
//                 { label: "MSME No.", key: "MSMENo" },
//                 { label: "Transporter", key: "Transporter" },
//                 { label: "Distance (km)", key: "Distance" },
//                 { label: "State Code", key: "StateCode" },
//             ]
//         }
//     ];

//     return (
//         <Container sx={{ pt: { xs: 1, sm: 2 }, pb: { xs: 1, sm: 2 }, px: { xs: 1, sm: 2 }, maxWidth: { xs: "100%", sm: "100%", md: "1400px" } }}>
//             {/* Header Section with enhanced styling */}
//             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, gap: 2, flexWrap: "wrap" }}>
//                 <Box>
//                     <Typography
//                         variant="h4"
//                         sx={{
//                             fontWeight: 700,
//                             background: "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
//                             backgroundClip: "text",
//                             WebkitBackgroundClip: "text",
//                             WebkitTextFillColor: "transparent",
//                             fontSize: { xs: "1.5rem", sm: "2rem", md: "2.25rem" },
//                             letterSpacing: "-0.5px"
//                         }}
//                     >
//                         Client Data Upload
//                     </Typography>
//                     <Typography
//                         variant="body2"
//                         sx={{
//                             color: "text.secondary",
//                             mt: 0.5,
//                             fontSize: { xs: "0.8rem", sm: "0.95rem" }
//                         }}
//                     >
//                         Manage and import your client information
//                     </Typography>
//                 </Box>
//                 <Tooltip title="Back to Options" placement="left">
//                     <IconButton
//                         onClick={handleBackClick}
//                         sx={{
//                             bgcolor: "#1976d2",
//                             color: "white",
//                             width: { xs: 40, sm: 48 },
//                             height: { xs: 40, sm: 48 },
//                             "&:hover": {
//                                 bgcolor: "#115293",
//                                 transform: "translateY(-2px)",
//                                 boxShadow: "0 6px 16px rgba(25, 118, 210, 0.4)"
//                             },
//                             borderRadius: 1.5,
//                             transition: "all 0.3s ease",
//                             boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
//                             flexShrink: 0
//                         }}
//                     >
//                         <ArrowBackIcon sx={{ fontSize: { xs: 22, sm: 26 } }} />
//                     </IconButton>
//                 </Tooltip>
//             </Box>

//             <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
//                 {/* File Upload Card */}
//                 <Paper sx={{
//                     px: { xs: 3, sm: 3.5 },
//                     py: { xs: 2, sm: 2.5 },
//                     borderRadius: { xs: 2.5, sm: 3 },
//                     bgcolor: "background.paper",
//                     boxShadow: "0 4px 16px rgba(25, 118, 210, 0.4)",
//                     border: `1px solid ${alpha('#1976d2', 0.1)}`,
//                     position: "relative",
//                     overflow: "hidden",
//                     "&::before": {
//                         content: '""',
//                         position: "absolute",
//                         top: 0,
//                         left: 0,
//                         right: 0,
//                         height: 1,
//                         background: `linear-gradient(90deg, transparent, rgba(25, 118, 210, 0.3), transparent)`,
//                     }
//                 }}>
//                     <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
//                         {/* File Upload Zone */}
//                         <FileUploadZone fileInputRef={fileInputRef} file={file} handleFileChange={handleFileChange} data={data} />

//                         {/* Upload Controls & Progress */}
//                         {(file || data.length > 0) && (
//                             <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: { xs: "space-between", sm: "flex-start" } }}>
//                                 <Button
//                                     variant="contained"
//                                     onClick={handleUploadSubmit}
//                                     disabled={uploading || !data.length || validRowsCount === 0}
//                                     sx={{
//                                         height: { xs: 40, sm: 44 },
//                                         bgcolor: "#1976d2",
//                                         "&:hover": {
//                                             bgcolor: "#115293",
//                                             boxShadow: "0 6px 20px rgba(25, 118, 210, 0.4)",
//                                             transform: "translateY(-2px)"
//                                         },
//                                         borderRadius: 1.5,
//                                         textTransform: "none",
//                                         fontWeight: 700,
//                                         px: { xs: 2, sm: 3 },
//                                         "&.Mui-disabled": { bgcolor: "#bdbdbd", color: "#666" },
//                                         fontSize: { xs: "0.95rem", sm: "1.05rem" },
//                                         minWidth: { xs: "auto", sm: 140 },
//                                         transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//                                         boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
//                                         gap: 1
//                                     }}
//                                 >
//                                     {uploading ? <CircularProgress size={22} color="inherit" /> : <InsertDriveFileIcon sx={{ fontSize: 22 }} />}
//                                     {uploading ? "Uploading..." : "Upload Records"}
//                                 </Button>
//                                 {showBuffer && (
//                                     <Box sx={{ width: { xs: "100%", sm: 280 } }}>
//                                         <LinearProgress
//                                             variant="buffer"
//                                             value={progressValue}
//                                             valueBuffer={bufferValue}
//                                             sx={{
//                                                 height: 4,
//                                                 borderRadius: 4,
//                                                 backgroundColor: alpha('#1976d2', 0.1),
//                                                 "& .MuiLinearProgress-bar": {
//                                                     borderRadius: 4,
//                                                     background: "linear-gradient(90deg, #1976d2, #42a5f5)"
//                                                 }
//                                             }}
//                                         />
//                                         <Typography
//                                             variant="caption"
//                                             sx={{
//                                                 display: "block",
//                                                 textAlign: "center",
//                                                 fontSize: { xs: "0.75rem", sm: "0.85rem" },
//                                                 fontWeight: 600,
//                                                 color: "#1976d2"
//                                             }}
//                                         >
//                                             {uploading ? `${Math.round(progressValue)}%` : `Ready`}
//                                         </Typography>
//                                     </Box>
//                                 )}
//                             </Box>
//                         )}

//                         {/* Statistics Chips */}
//                         {data.length > 0 && (
//                             <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", justifyContent: { xs: "center", sm: "flex-end" } }}>
//                                 <Chip
//                                     icon={<CheckCircleIcon sx={{ fontSize: 18 }} />}
//                                     label={`${perfectCount} Valid`}
//                                     onClick={() => setFilterMode(prev => prev === 'perfect' ? 'all' : 'perfect')}
//                                     variant={filterMode === 'perfect' ? "filled" : "outlined"}
//                                     sx={{
//                                         bgcolor: filterMode === 'perfect' ? '#4caf50' : 'transparent',
//                                         color: filterMode === 'perfect' ? 'white' : '#4caf50',
//                                         fontWeight: 700,
//                                         border: filterMode === 'perfect' ? 'none' : '2px solid #4caf50',
//                                         cursor: 'pointer',
//                                         transition: 'all 0.3s ease',
//                                         '&:hover': {
//                                             bgcolor: filterMode === 'perfect' ? '#388e3c' : alpha('#4caf50', 0.08),
//                                             transform: 'translateY(-2px)',
//                                             boxShadow: '0 4px 12px rgba(76, 175, 80, 0.3)'
//                                         },
//                                         fontSize: { xs: "0.8rem", sm: "0.95rem" }
//                                     }}
//                                 />
//                                 <Chip
//                                     icon={<ErrorIcon sx={{ fontSize: 18 }} />}
//                                     label={`${errorCount} Errors`}
//                                     onClick={() => setFilterMode(prev => prev === 'error' ? 'all' : 'error')}
//                                     variant={filterMode === 'error' ? "filled" : "outlined"}
//                                     sx={{
//                                         bgcolor: filterMode === 'error' ? '#f44336' : 'transparent',
//                                         color: filterMode === 'error' ? 'white' : '#f44336',
//                                         fontWeight: 700,
//                                         border: filterMode === 'error' ? 'none' : '2px solid #f44336',
//                                         cursor: 'pointer',
//                                         transition: 'all 0.3s ease',
//                                         '&:hover': {
//                                             bgcolor: filterMode === 'error' ? '#d32f2f' : alpha('#f44336', 0.08),
//                                             transform: 'translateY(-2px)',
//                                             boxShadow: '0 4px 12px rgba(244, 67, 54, 0.3)'
//                                         },
//                                         fontSize: { xs: "0.8rem", sm: "0.95rem" }
//                                     }}
//                                 />
//                             </Box>
//                         )}
//                     </Box>
//                 </Paper>

//                 {/* Data Display Section */}
//                 {data.length > 0 && (
//                     <GlassParentCard>
//                         {/* Search Bar */}
//                         <Box p={{ xs: 1, sm: 1.5 }} pb={1.5}>
//                             <TextField
//                                 fullWidth
//                                 size="small"
//                                 placeholder={isMobile ? "Search companies..." : "Search by company name, phone, email..."}
//                                 value={searchText}
//                                 onChange={(e) => setSearchText(e.target.value)}
//                                 InputProps={{
//                                     startAdornment: (
//                                         <InputAdornment position="start">
//                                             <SearchIcon sx={{ fontSize: 22, color: "#1976d2" }} />
//                                         </InputAdornment>
//                                     ),
//                                 }}
//                                 sx={{
//                                     "& .MuiOutlinedInput-root": {
//                                         borderRadius: 2,
//                                         bgcolor: "background.paper",
//                                         fontSize: { xs: "0.9rem", sm: "1rem" },
//                                         border: `1.5px solid ${alpha('#1976d2', 0.2)}`,
//                                         transition: "all 0.3s ease",
//                                         "&:hover": {
//                                             borderColor: alpha('#1976d2', 0.4)
//                                         },
//                                         "&.Mui-focused": {
//                                             borderColor: "#1976d2",
//                                             boxShadow: `0 0 0 3px ${alpha('#1976d2', 0.1)}`
//                                         }
//                                     }
//                                 }}
//                             />
//                         </Box>

//                         {/* Records Container */}
//                         <Box
//                             flex={1}
//                             overflow="auto"
//                             p={{ xs: 1.5, sm: 2 }}
//                             pt={0}
//                             sx={{
//                                 maxHeight: { xs: "calc(100vh - 380px)", sm: "calc(100vh - 300px)", md: "calc(78vh - 80px)" },
//                                 '&::-webkit-scrollbar': { width: '8px' },
//                                 '&::-webkit-scrollbar-track': { background: alpha('#1976d2', 0.05), borderRadius: '10px' },
//                                 '&::-webkit-scrollbar-thumb': {
//                                     background: '#1976d2',
//                                     borderRadius: '10px',
//                                     '&:hover': { background: '#115293' }
//                                 }
//                             }}
//                         >
//                             <Stack spacing={{ xs: 1.5, sm: 2, md: 2.5 }}>
//                                 {filteredData.length === 0 ? (
//                                     <Paper sx={{
//                                         p: 2.5,
//                                         textAlign: "center",
//                                         borderRadius: 3,
//                                         bgcolor: alpha("#1976d2", 0.02),
//                                         border: `1px dashed ${alpha("#1976d2", 0.2)}`
//                                     }}>
//                                         <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
//                                             <SearchIcon sx={{ fontSize: 48, color: alpha("#1976d2", 0.3), mb: 1 }} />
//                                             <Typography variant="h6" color="text.secondary" sx={{ fontSize: { xs: "1rem", sm: "1.1rem" }, fontWeight: 600 }}>
//                                                 {searchText || filterMode !== 'all' ? "No records match your search" : "No data loaded"}
//                                             </Typography>
//                                         </Box>
//                                     </Paper>
//                                 ) : (
//                                     filteredData.map((r, idx) => {
//                                         const missing = r._missingFields || [];
//                                         const isError = missing.length > 0;
//                                         const expanded = expandedCards[r.id];
//                                         const statusInfo = rowStatus[r.id];
//                                         const isFading = fadeOutIds.has(r.id);

//                                         let cardBg = "background.paper";
//                                         let borderColor = alpha('#1976d2', 0.2);
//                                         let statusChip = null;

//                                         if (statusInfo) {
//                                             if (statusInfo.status === 201) {
//                                                 cardBg = "#e8f5e9";
//                                                 borderColor = "#4caf50";
//                                                 statusChip = { color: "#1b5e20", bg: "#4caf50", icon: <CheckCircleOutlineIcon sx={{ fontSize: 14 }} />, label: "✓ Inserted" };
//                                             } else if ([204, 304].includes(statusInfo.status)) {
//                                                 cardBg = "#fff8e1";
//                                                 borderColor = "#ffb300";
//                                                 statusChip = { color: "#ff8f00", bg: "#ffb300", icon: <WarningIcon sx={{ fontSize: 14 }} />, label: "Already Exists" };
//                                             } else {
//                                                 cardBg = "#ffebee";
//                                                 borderColor = "#f44336";
//                                                 statusChip = { color: "#c62828", bg: "#f44336", icon: <ErrorIcon sx={{ fontSize: 14 }} />, label: "Failed" };
//                                             }
//                                         } else if (isError) {
//                                             cardBg = "#ffebee";
//                                             borderColor = "#f44336";
//                                         }

//                                         return (
//                                             <Card
//                                                 key={r.id}
//                                                 elevation={isError ? 4 : 2}
//                                                 sx={{
//                                                     borderRadius: { xs: 2, sm: 2.5, md: 3 },
//                                                     bgcolor: cardBg,
//                                                     border: `2px solid ${borderColor}`,
//                                                     position: "relative",
//                                                     overflow: "visible",
//                                                     transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
//                                                     opacity: isFading ? 0 : 1,
//                                                     transform: isFading ? "translateY(-20px) scale(0.95)" : "translateY(0)",
//                                                     height: isFading ? 0 : "auto",
//                                                     marginBottom: isFading ? "-10px" : { xs: 1, sm: 2 },
//                                                     padding: isFading ? 0 : { xs: 1, sm: 1.5 },
//                                                     "&:hover": {
//                                                         boxShadow: isError ? "0 12px 28px rgba(244, 67, 54, 0.15)" : "0 12px 28px rgba(25, 118, 210, 0.15)",
//                                                     }
//                                                 }}
//                                             >
//                                                 {statusChip && !isFading && (
//                                                     <Box
//                                                         sx={{
//                                                             position: "absolute",
//                                                             bottom: 8,
//                                                             right: 12,
//                                                             bgcolor: statusChip.bg,
//                                                             color: statusChip.bg === '#ffb300' ? '#000' : 'white',
//                                                             px: 1.25,
//                                                             py: 0.4,
//                                                             borderRadius: 1.5,
//                                                             fontSize: { xs: "0.7rem", sm: "0.8rem" },
//                                                             fontWeight: 700,
//                                                             display: "flex",
//                                                             alignItems: "center",
//                                                             gap: 0.5,
//                                                             zIndex: 1,
//                                                             boxShadow: `0 2px 8px ${alpha(statusChip.bg, 0.3)}`
//                                                         }}
//                                                     >
//                                                         {statusChip.icon}
//                                                         {statusChip.label}
//                                                     </Box>
//                                                 )}

//                                                 <CardContent sx={{ pt: { xs: 2, sm: 2.5 }, pb: statusChip ? { xs: 4, sm: 5 } : { xs: 1.5, sm: 2 }, px: { xs: 1.5, sm: 2.5 } }}>
//                                                     {/* Main Header Row */}
//                                                     <Box
//                                                         sx={{
//                                                             display: 'flex',
//                                                             justifyContent: 'space-between',
//                                                             alignItems: 'flex-start',
//                                                             gap: { xs: 1.5, sm: 2, md: 4 },
//                                                             flexWrap: { xs: "wrap", sm: "nowrap" }
//                                                         }}
//                                                     >
//                                                         {/* Company Info */}
//                                                         <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1.5, sm: 2.5 }, flex: { xs: "0 0 100%", sm: 1 } }}>
//                                                             <Box
//                                                                 sx={{
//                                                                     background: statusInfo?.status === 201 ? "linear-gradient(135deg, #4caf50, #66bb6a)" : (isError ? "linear-gradient(135deg, #f44336, #ef5350)" : "linear-gradient(135deg, #1976d2, #42a5f5)"),
//                                                                     color: "white",
//                                                                     width: { xs: 40, sm: 48 },
//                                                                     height: { xs: 40, sm: 48 },
//                                                                     borderRadius: 2,
//                                                                     display: "flex",
//                                                                     alignItems: "center",
//                                                                     justifyContent: "center",
//                                                                     fontWeight: 700,
//                                                                     flexShrink: 0,
//                                                                     fontSize: { xs: "1.1rem", sm: "1.3rem" },
//                                                                     boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)"
//                                                                 }}
//                                                             >
//                                                                 {r.CompanyName?.[0]?.toUpperCase() || "?"}
//                                                             </Box>
//                                                             <Box sx={{ minWidth: 0, flex: 1 }}>
//                                                                 <Typography
//                                                                     variant="h6"
//                                                                     fontWeight={700}
//                                                                     noWrap
//                                                                     sx={{ fontSize: { xs: "1rem", sm: "1.1rem", md: "1.3rem" }, letterSpacing: "-0.3px" }}
//                                                                 >
//                                                                     {r.CompanyName || "Unnamed"}
//                                                                 </Typography>
//                                                                 <Typography
//                                                                     variant="body2"
//                                                                     color="text.secondary"
//                                                                     noWrap
//                                                                     sx={{ fontSize: { xs: "0.75rem", sm: "0.9rem" }, mt: 0.25 }}
//                                                                 >
//                                                                     {r.ContactPerson || "—"} • {r.MobileNo || "—"}
//                                                                 </Typography>
//                                                             </Box>
//                                                         </Box>

//                                                         {/* Quick Info - Responsive Grid */}
//                                                         <Box
//                                                             sx={{
//                                                                 display: 'grid',
//                                                                 gridTemplateColumns: { xs: "1fr 1fr", sm: "repeat(4, 1fr)" },
//                                                                 gap: { xs: 1.25, sm: 1.75 },
//                                                                 alignItems: 'flex-start',
//                                                                 flex: { xs: "0 0 100%", sm: "auto" },
//                                                                 width: { xs: "100%", sm: "auto" }
//                                                             }}
//                                                         >
//                                                             {[
//                                                                 { label: "GST No.", value: r.GSTNo || "—", key: "GSTNo", icon: "🏛️" },
//                                                                 { label: "Email", value: r.EmailId || "—", key: "EmailId", icon: "✉️" },
//                                                                 { label: "Alt Mobile", value: r.AlternateMobile || "—", key: "AlternateMobile", icon: "📱" },
//                                                                 { label: "Location", value: `${r.City || ""}, ${r.State || ""}`.trim() || "—", key: "City", icon: "📍" }
//                                                             ].map((item, i) => {
//                                                                 const hasErr = hasFieldError(r, item.key);
//                                                                 return (
//                                                                     <Box
//                                                                         key={i}
//                                                                         sx={{
//                                                                             bgcolor: hasErr ? alpha('#f44336', 0.08) : alpha('#1976d2', 0.04),
//                                                                             borderRadius: 1.5,
//                                                                             p: 1,
//                                                                             transition: 'all 0.2s ease',
//                                                                             display: 'flex',
//                                                                             flexDirection: 'column',
//                                                                             alignItems: 'flex-start',
//                                                                             minWidth: 0,
//                                                                             border: `1px solid ${hasErr ? alpha('#f44336', 0.2) : alpha('#1976d2', 0.1)}`
//                                                                         }}
//                                                                     >
//                                                                         <Typography
//                                                                             variant="caption"
//                                                                             sx={{
//                                                                                 fontWeight: 700,
//                                                                                 color: hasErr ? '#f44336' : 'text.secondary',
//                                                                                 lineHeight: 1.3,
//                                                                                 fontSize: { xs: "0.7rem", sm: "0.8rem" },
//                                                                                 textTransform: "uppercase",
//                                                                                 letterSpacing: "0.5px"
//                                                                             }}
//                                                                         >
//                                                                             {item.label}
//                                                                         </Typography>
//                                                                         <Typography
//                                                                             variant="body2"
//                                                                             fontWeight={600}
//                                                                             noWrap
//                                                                             sx={{
//                                                                                 mt: 0.4,
//                                                                                 wordBreak: 'break-word',
//                                                                                 maxWidth: '100%',
//                                                                                 fontSize: { xs: "0.75rem", sm: "0.9rem" },
//                                                                                 color: "#000"
//                                                                             }}
//                                                                         >
//                                                                             {item.value}
//                                                                         </Typography>
//                                                                     </Box>
//                                                                 );
//                                                             })}
//                                                         </Box>

//                                                         {/* Expand Button */}
//                                                         <IconButton
//                                                             size="small"
//                                                             onClick={() => toggleExpand(r.id)}
//                                                             sx={{
//                                                                 alignSelf: 'flex-start',
//                                                                 flexShrink: 0,
//                                                                 bgcolor: alpha('#1976d2', 0.1),
//                                                                 color: '#1976d2',
//                                                                 transition: 'all 0.3s ease',
//                                                                 "&:hover": {
//                                                                     bgcolor: alpha('#1976d2', 0.2),
//                                                                     transform: 'scale(1.1)'
//                                                                 }
//                                                             }}
//                                                         >
//                                                             {expanded ? <ExpandLessIcon sx={{ fontSize: { xs: 20, sm: 24 } }} /> : <ExpandMoreIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />}
//                                                         </IconButton>
//                                                     </Box>

//                                                     {/* Expanded Details */}
//                                                     <Collapse in={expanded} timeout="auto" unmountOnExit>
//                                                         <Divider sx={{ my: 1.5 }} />
//                                                         <Box mt={1.5}>
//                                                             {fieldGroups.map((group, gIdx) => (
//                                                                 <Box key={gIdx} mb={2}>
//                                                                     <Typography
//                                                                         variant="subtitle2"
//                                                                         color="primary"
//                                                                         gutterBottom
//                                                                         sx={{
//                                                                             display: "flex",
//                                                                             alignItems: "center",
//                                                                             gap: 0.75,
//                                                                             fontSize: { xs: "0.85rem", sm: "1rem" },
//                                                                             fontWeight: 700,
//                                                                             textTransform: "uppercase",
//                                                                             letterSpacing: "0.5px"
//                                                                         }}
//                                                                     >
//                                                                         {group.icon} {group.title}
//                                                                     </Typography>
//                                                                     <Grid container spacing={{ xs: 1, sm: 1.5 }}>
//                                                                         {group.fields.map((f, fIdx) => (
//                                                                             <Grid item xs={12} sm={6} key={fIdx}>
//                                                                                 <Box sx={{ p: 1, borderRadius: 1.5, bgcolor: alpha('#1976d2', 0.02), border: `1px solid ${alpha('#1976d2', 0.1)}` }}>
//                                                                                     <Typography
//                                                                                         variant="caption"
//                                                                                         sx={{
//                                                                                             color: hasFieldError(r, f.key) ? '#f44336' : 'text.secondary',
//                                                                                             fontWeight: hasFieldError(r, f.key) ? 700 : 600,
//                                                                                             fontSize: { xs: "0.7rem", sm: "0.8rem" },
//                                                                                             textTransform: "uppercase",
//                                                                                             letterSpacing: "0.3px"
//                                                                                         }}
//                                                                                     >
//                                                                                         {f.label}
//                                                                                     </Typography>
//                                                                                     <Typography
//                                                                                         variant="body2"
//                                                                                         fontWeight={600}
//                                                                                         sx={{ fontSize: { xs: "0.8rem", sm: "0.9rem" }, mt: 0.5 }}
//                                                                                     >
//                                                                                         {r[f.key] || "—"}
//                                                                                     </Typography>
//                                                                                 </Box>
//                                                                             </Grid>
//                                                                         ))}
//                                                                     </Grid>
//                                                                 </Box>
//                                                             ))}
//                                                         </Box>
//                                                     </Collapse>
//                                                 </CardContent>
//                                             </Card>
//                                         );
//                                     })
//                                 )}
//                             </Stack>
//                         </Box>
//                     </GlassParentCard>
//                 )}
//             </Box>

//             {/* Snackbar */}
//             <Snackbar
//                 open={snackbar.open}
//                 autoHideDuration={6000}
//                 onClose={() => setSnackbar({ ...snackbar, open: false })}
//                 anchorOrigin={{ vertical: "top", horizontal: "center" }}
//             >
//                 <Alert
//                     onClose={() => setSnackbar({ ...snackbar, open: false })}
//                     severity={snackbar.severity}
//                     sx={{
//                         width: "100%",
//                         fontSize: { xs: "0.85rem", sm: "0.95rem" },
//                         fontWeight: 600,
//                         boxShadow: "0 4px 16px rgba(0, 0, 0, 0.15)"
//                     }}
//                 >
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Container>
//     );
// };

// export default InsertClient;





// import React, { useState, useRef, useMemo, useEffect } from "react";
// import { Box, Button, Container, Typography, Snackbar, Alert, CircularProgress, LinearProgress, Card, CardContent, Grid, TextField, InputAdornment, Paper, Divider, Stack, IconButton, Collapse, alpha, Chip, Tooltip, useMediaQuery, useTheme } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import * as XLSX from "xlsx";
// import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
// import SearchIcon from '@mui/icons-material/Search';
// import BusinessIcon from '@mui/icons-material/Business';
// import PhoneIcon from '@mui/icons-material/Phone';
// import EmailIcon from '@mui/icons-material/Email';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import WarningIcon from '@mui/icons-material/Warning';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import ExpandLessIcon from '@mui/icons-material/ExpandLess';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import ErrorIcon from '@mui/icons-material/Error';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import { useAuth } from '../context/AuthContext';

// // Simple UUID-like ID generator for unique row IDs
// const generateUniqueId = () => {
//     return `row-${Math.random().toString(36).substr(2, 9)}-${Date.now().toString(36)}`;
// };

// // Modern Glass Card with enhanced styling
// const GlassParentCard = ({ children }) => (
//     <Paper
//         elevation={0}
//         sx={{
//             borderRadius: { xs: 2, sm: 3, md: 4 },
//             background: (theme) => `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.95)} 0%, ${alpha(theme.palette.background.paper, 0.85)} 100%)`,
//             backdropFilter: "blur(20px)",
//             WebKitBackdropFilter: "blur(20px)",
//             border: `1px solid ${(theme) => alpha(theme.palette.primary.main, 0.1)}`,
//             [`& .MuiPaper-root`]: { borderRadius: { xs: 2, sm: 3 } },
//             boxShadow: "0 20px 60px rgba(25, 118, 210, 0.08), 0 0 1px rgba(25, 118, 210, 0.1)",
//             position: "relative",
//             overflow: "hidden",
//             maxHeight: { xs: "calc(100vh - 300px)", sm: "calc(100vh - 250px)", md: "78vh" },
//             display: "flex",
//             flexDirection: "column",
//             "&::before": {
//                 content: '""',
//                 position: "absolute",
//                 top: 0,
//                 left: 0,
//                 right: 0,
//                 height: 1,
//                 background: `linear-gradient(90deg, transparent, rgba(25, 118, 210, 0.3), transparent)`,
//             },
//             "&::after": {
//                 content: '""',
//                 position: "absolute",
//                 top: 0,
//                 left: 0,
//                 width: 4,
//                 height: "100%",
//                 background: "linear-gradient(180deg, #1976d2, #42a5f5, transparent)",
//                 borderRadius: "0 8px 8px 0",
//             }
//         }}
//     >
//         {children}
//     </Paper>
// );

// // Enhanced File Upload Zone
// const FileUploadZone = ({ fileInputRef, file, handleFileChange, data }) => {
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//     const [isDragOver, setIsDragOver] = useState(false);

//     const handleDragOver = (e) => {
//         e.preventDefault();
//         setIsDragOver(true);
//     };

//     const handleDragLeave = () => {
//         setIsDragOver(false);
//     };

//     const handleDrop = (e) => {
//         e.preventDefault();
//         setIsDragOver(false);
//         const droppedFiles = e.dataTransfer.files;
//         if (droppedFiles.length > 0) {
//             fileInputRef.current.files = droppedFiles;
//             const event = new Event('change', { bubbles: true });
//             Object.defineProperty(event, 'target', { value: fileInputRef.current, enumerable: true });
//             handleFileChange(event);
//         }
//     };

//     return (
//         <Box
//             onDragOver={handleDragOver}
//             onDragLeave={handleDragLeave}
//             onDrop={handleDrop}
//             sx={{
//                 position: "relative",
//                 borderRadius: { xs: 2, sm: 3 },
//                 border: `2px dashed ${isDragOver ? '#1976d2' : alpha('#1976d2', 0.3)}`,
//                 p: { xs: 2, sm: 3 },
//                 textAlign: "center",
//                 transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//                 background: isDragOver ? alpha('#1976d2', 0.05) : alpha('#1976d2', 0.02),
//                 cursor: "pointer",
//                 "&:hover": {
//                     borderColor: '#1976d2',
//                     bgcolor: alpha('#1976d2', 0.04),
//                 },
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 minHeight: { xs: 120, sm: 140 },
//                 gap: 2,
//             }}
//         >
//             <input type="file" accept=".xlsx,.xls,.csv" onChange={handleFileChange} ref={fileInputRef} style={{ display: "none" }} id="file-upload" />

//             <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
//                 <CloudUploadIcon sx={{ fontSize: { xs: 40, sm: 50 }, color: '#1976d2', opacity: 0.7 }} />
//                 <Box>
//                     <Typography
//                         variant="body1"
//                         sx={{
//                             fontWeight: 600,
//                             color: "#1976d2",
//                             fontSize: { xs: "0.95rem", sm: "1.1rem" },
//                             mb: 0.5
//                         }}
//                     >
//                         {file ? `Selected: ${file.name}` : "Drop your file here or click to browse"}
//                     </Typography>
//                     <Typography
//                         variant="caption"
//                         sx={{
//                             color: "text.secondary",
//                             fontSize: { xs: "0.75rem", sm: "0.875rem" }
//                         }}
//                     >
//                         Excel (.xlsx, .xls) or CSV files only
//                     </Typography>
//                 </Box>
//             </Box>

//             <Button
//                 variant="contained"
//                 onClick={(e) => {
//                     e.stopPropagation();
//                     const hasError = data.some(r => r._missingFields?.length > 0);
//                     if (data.length > 0 && hasError && !window.confirm("There are rows with errors. Are you sure you want to choose a new file?")) {
//                         return;
//                     }
//                     fileInputRef.current.click();
//                 }}
//                 sx={{
//                     height: { xs: 36, sm: 40 },
//                     bgcolor: "#1976d2",
//                     "&:hover": { bgcolor: "#115293" },
//                     borderRadius: 1.5,
//                     textTransform: "none",
//                     fontWeight: 600,
//                     px: { xs: 2, sm: 2.5 },
//                     whiteSpace: "nowrap",
//                     fontSize: { xs: "0.85rem", sm: "0.95rem" },
//                     boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
//                     transition: "all 0.3s ease",
//                     "&:hover": {
//                         bgcolor: "#115293",
//                         boxShadow: "0 6px 16px rgba(25, 118, 210, 0.4)",
//                         transform: "translateY(-2px)"
//                     }
//                 }}
//             >
//                 Browse
//             </Button>
//         </Box>
//     );
// };

// const InsertClient = ({ connectionString }) => {
//     const { user, selectedCompany, loading } = useAuth();
//     const path = connectionString;
//     const navigate = useNavigate();
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//     const isTablet = useMediaQuery(theme.breakpoints.down('md'));
//     const fileInputRef = useRef(null);
//     const [file, setFile] = useState(null);
//     const [data, setData] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [uploading, setUploading] = useState(false);
//     const [uploadProgress, setUploadProgress] = useState(0);
//     const [progressValue, setProgressValue] = useState(0);
//     const [bufferValue, setBufferValue] = useState(0);
//     const [showBuffer, setShowBuffer] = useState(false);
//     const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
//     const [searchText, setSearchText] = useState("");
//     const [expandedCards, setExpandedCards] = useState({});
//     const [filterMode, setFilterMode] = useState('all');
//     const [clientCategory, setClientCategory] = useState("");
//     const [insertedIds, setInsertedIds] = useState(new Set());
//     const [fadeOutIds, setFadeOutIds] = useState(new Set());
//     const [rowStatus, setRowStatus] = useState({});
//     const [accGroups, setAccGroups] = useState([]);

//     const toggleExpand = (id) => setExpandedCards(prev => ({ ...prev, [id]: !prev[id] }));
//     const clientCategoryOptions = [{ display: "Bank Receipt", value: "Br" }, { display: "Cash Receipt", value: "Cr" }];

//     console.log("InsertClient props:", { user, selectedCompany, connectionString });

//     const companyId = selectedCompany?.CompId || null;
//     const fYear = getCurrentFYear();
//     const userId = user?.UserId || null;
//     const AppRegID = selectedCompany?.AppRegID || null;

//     const isSubGroupExists = (subGrpName) => {
//         if (!subGrpName || !accGroups.length) return false;

//         return accGroups.some(
//             ag =>
//                 ag.SubGrpName?.trim().toLowerCase() ===
//                 String(subGrpName).trim().toLowerCase()
//         );
//     };

//     const checkCategoryDuplicate = async (categoryName) => {
//         try {
//             const categoryId = getCategoryId(categoryName);

//             if (!categoryName || categoryId == null) {
//                 return false;
//             }

//             const res = await axios.get(
//                 `${path}/client/check-category`,
//                 {
//                     params: {
//                         companyId,
//                         categoryId
//                     }
//                 }
//             );

//             // 200 means not duplicate
//             return res.data?.duplicate === true;

//         } catch (err) {

//             // 400 means duplicate
//             if (err?.response?.status === 400) {
//                 return true;
//             }

//             console.error("Category validation failed:", err);

//             // API failure should not mark duplicate
//             return false;
//         }
//     };

//     const categoryOptions = [
//         { id: 0, value: "---NONE---" },
//         { id: 1, value: "LOCAL" },
//         { id: 2, value: "INTER-STATE" },
//         { id: 3, value: "BANK/CASH/REGISTER" },
//         { id: 6, value: "CGST" },
//         { id: 7, value: "SGST" },
//         { id: 8, value: "IGST" },
//         { id: 9, value: "UTGST" },
//         { id: 10, value: "CESS" },
//         { id: 11, value: "ROUNDOFF" },
//         { id: 12, value: "RCM CGST" },
//         { id: 13, value: "RCM SGST" },
//         { id: 14, value: "RCM IGST" },
//         { id: 15, value: "RCM UTGST" },
//         { id: 16, value: "RCM GSTCESS" },
//         { id: 17, value: "AGENT" },
//         { id: 18, value: "TCS" },
//         { id: 19, value: "TDS" }
//     ];

//     const getCategoryId = (excelValue) => {
//         if (!excelValue) return null;

//         const normalized = String(excelValue)
//             .trim()
//             .replace(/\s+/g, " ")
//             .toUpperCase();

//         const found = categoryOptions.find(
//             c => c.value.toUpperCase() === normalized
//         );

//         return found ? found.id : null;
//     };

//     // ✅ Helper function to find account group ID by GrpName and SubGrpName
//     const getAccGroupIdByGroupAndSubGroup = (grpName, subGrpName) => {
//         if (!grpName || !subGrpName || !accGroups.length) return null;
//         const group = accGroups.find(
//             ag => (ag.GrpName?.toLowerCase() === String(grpName).trim().toLowerCase() &&
//                 ag.SubGrpName?.toLowerCase() === String(subGrpName).trim().toLowerCase()) ||
//                 (ag.GroupName?.toLowerCase() === String(grpName).trim().toLowerCase() &&
//                     ag.AccGroupName?.toLowerCase() === String(subGrpName).trim().toLowerCase())
//         );
//         return group ? group.AccGrpID || group.id : null;
//     };

//     // ✅ Fetch account groups on mount
//     useEffect(() => {
//         const Hlp_Fn_AccUnderGroup = async () => {
//             try {
//                 const { data } = await axios.get(`${path}/api/client-get-data/api/AccUnderGroup`, {
//                     params: { companyId },
//                     headers: { "Cache-Control": "no-cache" }
//                 });
//                 const remapped = (data || []).map(item => ({
//                     ...item,
//                     displayLabel: `${item.SubGrpName || item.AccGroupName || ''}[${item.GrpName || item.GroupName || ''}]`
//                 }));
//                 setAccGroups(remapped || []);
//             } catch (err) {
//                 if (err?.response?.status === 404) {
//                     setAccGroups([]);
//                 } else {
//                     console.error(err);
//                 }
//             }
//         };
//         if (companyId) {
//             Hlp_Fn_AccUnderGroup();
//         }
//     }, [companyId, path]);

//     const updateProgress = (value) => {
//         const clipped = Math.max(0, Math.min(100, value));
//         setProgressValue(clipped);
//         setBufferValue(Math.min(100, clipped + 10));
//     };

//     // Helper to check if a field has an error
//     const hasFieldError = (record, fieldKey) => {
//         if (!record._missingFields) return false;
//         const fieldMap = {
//             GSTNo: "GST No.",
//             CompanyName: "Company Name",
//             CategoryCode: "Category",
//             ClientCategory: "Client Category",
//             ClientCode: "Client Code",
//             GrpName: "GrpName",
//             SubGrpName: "SubGrpName",
//             Address: "Address",
//             Landmark: "Landmark",
//             Pincode: "Pincode",
//             City: "City",
//             State: "State",
//             StateCode: "State Code",
//             Country: "Country",
//             Distance: "Distance",
//             ContactPerson: "Contact Person",
//             MobileNo: "Mobile No.",
//             AlternateMobileNo: "Alt Mobile",
//             EmailId: "Email Id",
//             AlternateEmailId: "Alternate Email",
//             Website: "Website",
//             PANNo: "PAN No.",
//             AadharNo: "Aadhar No.",
//             MSMENo: "MSME No.",
//             Transporter: "Transporter",
//             AgentName: "Agent Name",
//             AgentCommission: "Agent Commission (%)",
//             PaymentDays: "Payment Days",
//             CreditLimit: "Credit Limit",
//             Interest: "Interest (%)",
//             Disc: "Discount (%)"
//         };
//         const errorLabel = fieldMap[fieldKey];
//         return errorLabel
//             ? record._missingFields.some(
//                 err =>
//                     err.includes(errorLabel) ||
//                     (fieldKey === "SubGrpName" &&
//                         err.includes("First enter SubGroupName"))
//             )
//             : false;
//     };

//     useEffect(() => {
//         const hasRedError = data.some(r => r._missingFields?.length > 0);
//         const handleBeforeUnload = (e) => {
//             if (hasRedError && data.length > 0) {
//                 e.preventDefault();
//                 e.returnValue = '';
//             }
//         };
//         window.addEventListener('beforeunload', handleBeforeUnload);
//         return () => window.removeEventListener('beforeunload', handleBeforeUnload);
//     }, [data]);

//     const handleFileChange = (e) => {
//         const selectedFile = e.target.files[0];
//         if (selectedFile) {
//             const validExtensions = [".xlsx", ".xls", ".csv"];
//             const fileExtension = selectedFile.name.slice(selectedFile.name.lastIndexOf(".")).toLowerCase();
//             if (!validExtensions.includes(fileExtension)) {
//                 setSnackbar({ open: true, message: "Only Excel (.xlsx, .xls) or CSV (.csv) files are allowed", severity: "error" });
//                 setFile(null);
//                 setData([]);
//                 setFilteredData([]);
//                 fileInputRef.current.value = "";
//                 return;
//             }

//             setFile(selectedFile);
//             fileInputRef.current.value = null;

//             // Reset all states
//             setData([]);
//             setFilteredData([]);
//             setRowStatus({});
//             setFadeOutIds(new Set());
//             setShowBuffer(true);
//             setFilterMode('all');
//             updateProgress(3);

//             // Clone file to force fresh read
//             const clonedFile = new File([selectedFile], selectedFile.name, { type: selectedFile.type });
//             processFile(clonedFile);
//         }
//     };

//     const processFile = (file) => {
//         const reader = new FileReader();

//         reader.onprogress = (e) => {
//             if (e.lengthComputable) {
//                 const percentRead = Math.round((e.loaded / e.total) * 100);
//                 const mapped = Math.round(percentRead * 0.5);
//                 updateProgress(mapped);
//             }
//         };

//         reader.onload = async (e) => {
//             try {
//                 const binaryData = e.target.result;
//                 const workbook = XLSX.read(binaryData, { type: "binary" });
//                 const sheetName = workbook.SheetNames[0];
//                 const sheet = workbook.Sheets[sheetName];
//                 const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

//                 // ✅ Expected headers from Excel file
//                 const expectedHeaders = [
//                     "GSTNo", "CompanyName", "CategoryCode", "ClientCategory", "ClientCode", "GrpName", "SubGrpName",
//                     "Address", "Landmark", "Pincode", "City", "State", "StateCode", "Country", "Distance",
//                     "ContactPerson", "MobileNo", "AlternateMobileNo", "EmailId", "AlternateEmailId",
//                     "Website", "PANNo", "AadharNo", "MSMENo", "Transporter", "AgentName",
//                     "AgentCommission", "PaymentDays", "CreditLimit", "Interest", "Disc"
//                 ];

//                 const headers = jsonData[0] || [];
//                 const headersValid = expectedHeaders.every((header, index) => header === headers[index]);

//                 if (!headersValid) {
//                     setSnackbar({ open: true, message: "Invalid file format. Expected headers: " + expectedHeaders.join(", "), severity: "error" });
//                     setData([]);
//                     setFilteredData([]);
//                     updateProgress(0);
//                     setShowBuffer(false);
//                     return;
//                 }

//                 // ✅ Required fields from Excel (orange background)
//                 const requiredFields = [
//                     { key: 'CompanyName', label: 'Company Name' },
//                     { key: 'CategoryCode', label: 'Category' },
//                     { key: 'GrpName', label: 'GrpName' },
//                     { key: 'SubGrpName', label: 'SubGrpName' }
//                 ];

//                 const parsedData = (
//                     await Promise.all(
//                         jsonData.slice(1).map(async (row) => {
//                             const record = {
//                                 id: generateUniqueId(),

//                                 GSTNo: row[0] || "",
//                                 CompanyName: row[1] || "",
//                                 CategoryCode: row[2] || "",
//                                 ClientCategory: row[3] || "",
//                                 ClientCode: row[4] || "",
//                                 GrpName: row[5] || "",
//                                 SubGrpName: row[6] || "",
//                                 Address: row[7] || "",
//                                 Landmark: row[8] || "",
//                                 Pincode: row[9] || "",
//                                 City: row[10] || "",
//                                 State: row[11] || "",
//                                 StateCode: row[12] || "",
//                                 Country: row[13] || "",
//                                 Distance: row[14] || "",
//                                 ContactPerson: row[15] || "",
//                                 MobileNo: row[16] || "",
//                                 AlternateMobileNo: row[17] || "",
//                                 EmailId: row[18] || "",
//                                 AlternateEmailId: row[19] || "",
//                                 Website: row[20] || "",
//                                 PANNo: row[21] || "",
//                                 AadharNo: row[22] || "",
//                                 MSMENo: row[23] || "",
//                                 Transporter: row[24] || "",
//                                 AgentName: row[25] || "",
//                                 AgentCommission: row[26] || "",
//                                 PaymentDays: row[27] || "",
//                                 CreditLimit: row[28] || "",
//                                 Interest: row[29] || "",
//                                 Disc: row[30] || ""
//                             };

//                             const missing = requiredFields
//                                 .filter(f => !record[f.key] || String(record[f.key]).trim() === '')
//                                 .map(f => f.label);

//                             const validationErrors = [];

//                             if (
//                                 record.SubGrpName &&
//                                 !isSubGroupExists(record.SubGrpName)
//                             ) {
//                                 validationErrors.push(
//                                     "First enter SubGroupName from AccountGroup Master"
//                                 );
//                             }

//                             if (record.GSTNo && record.GSTNo.trim().length !== 15) {
//                                 validationErrors.push("GST No. must be 15 characters");
//                             }

//                             const pincodeStr = record.Pincode?.toString().trim();
//                             if (pincodeStr && (!/^\d{6}$/.test(pincodeStr))) {
//                                 validationErrors.push("Pincode must be 6 digits");
//                             }

//                             const mobileStr = record.MobileNo?.toString().trim();
//                             if (mobileStr && !/^\d{10}$/.test(mobileStr)) {
//                                 validationErrors.push("Mobile No. must be 10 digits");
//                             }

//                             const altMobileStr = record.AlternateMobileNo?.toString().trim();
//                             if (altMobileStr && !/^\d{10}$/.test(altMobileStr)) {
//                                 validationErrors.push("Alt Mobile must be 10 digits");
//                             }

//                             const aadharStr = record.AadharNo?.toString().trim();
//                             if (aadharStr && !/^\d{12}$/.test(aadharStr)) {
//                                 validationErrors.push("Aadhar No. must be 12 digits");
//                             }

//                             if (
//                                 record.CategoryCode &&
//                                 getCategoryId(record.CategoryCode) == null &&
//                                 record.CategoryCode.trim().toUpperCase() !== "---NONE---"
//                             ) {
//                                 validationErrors.push(
//                                     `Invalid Category: ${record.CategoryCode}`
//                                 );
//                             }

//                             // Same category duplicate logic untouched
//                             if (
//                                 record.CategoryCode &&
//                                 getCategoryId(record.CategoryCode) !== 0
//                             ) {
//                                 const isDuplicate = await checkCategoryDuplicate(
//                                     record.CategoryCode
//                                 );

//                                 if (isDuplicate) {
//                                     validationErrors.push(
//                                         `Category already exists: ${record.CategoryCode}`
//                                     );
//                                 }
//                             }

//                             record._missingFields = [
//                                 ...missing,
//                                 ...validationErrors
//                             ];

//                             return record;
//                         })
//                     )
//                 ).filter(row =>
//                     row.CompanyName ||
//                     row.ContactPerson ||
//                     row.MobileNo ||
//                     row.EmailId
//                 );

//                 setData(parsedData);
//                 setFilteredData(parsedData);
//                 setInsertedIds(new Set());
//                 setFadeOutIds(new Set());
//                 setRowStatus({});

//                 updateProgress(50);
//                 setSnackbar({ open: true, message: `Successfully parsed ${parsedData.length} records`, severity: "success" });

//                 updateProgress(100);
//                 setTimeout(() => {
//                     setShowBuffer(false);
//                     updateProgress(0);
//                 }, 800);
//             } catch (err) {
//                 console.error(err);
//                 setSnackbar({ open: true, message: "Error parsing file", severity: "error" });
//                 setData([]);
//                 setFilteredData([]);
//                 updateProgress(0);
//                 setShowBuffer(false);
//             }
//         };

//         reader.onerror = () => {
//             setSnackbar({ open: true, message: "Error reading file", severity: "error" });
//             setData([]);
//             setFilteredData([]);
//             updateProgress(0);
//             setShowBuffer(false);
//         };

//         reader.readAsBinaryString(file);
//     };

//     const handleUploadSubmit = async () => {
//         if (!data.length) {
//             setSnackbar({ open: true, message: "No data to upload", severity: "error" });
//             return;
//         }

//         const validRows = data.filter(r => !r._missingFields || r._missingFields.length === 0);
//         const errorRows = data.filter(r => r._missingFields?.length > 0);

//         if (validRows.length === 0) {
//             setSnackbar({ open: true, message: "All rows contain errors – nothing to insert", severity: "error" });
//             return;
//         }

//         if (!companyId || !userId) {
//             setSnackbar({ open: true, message: "Missing company/user data", severity: "error" });
//             return;
//         }

//         setUploading(true);
//         setShowBuffer(true);
//         updateProgress(0);

//         let insertedCount = 0;
//         let existsCount = 0;
//         let failedCount = 0;
//         const clientCategoryValue = clientCategoryOptions.find(option => option.display === clientCategory)?.value || "";

//         const insertedRowIds = [];

//         try {
//             for (let i = 0; i < validRows.length; i++) {
//                 const row = validRows[i];

//                 // ✅ Get account group ID using GrpName and SubGrpName
//                 const accGroupId = getAccGroupIdByGroupAndSubGroup(row.GrpName, row.SubGrpName);

//                 const payload = {
//                     gstNo: row.GSTNo,
//                     companyName: row.CompanyName,
//                     clientCode: row.ClientCode,
//                     clientCategory: clientCategoryValue,
//                     categoryId: getCategoryId(row.CategoryCode),
//                     address: row.Address,
//                     area: row.Landmark,
//                     pinCode: row.Pincode,
//                     city: row.City,
//                     state: row.State,
//                     stateCode: row.StateCode,
//                     country: row.Country,
//                     distance: row.Distance === "" ? 0 : parseFloat(row.Distance),
//                     contactPerson: row.ContactPerson,
//                     mobileNo: row.MobileNo,
//                     alternateMobile: row.AlternateMobileNo,
//                     emailId: row.EmailId,
//                     alternateEmailId: row.AlternateEmailId,
//                     website: row.Website,
//                     panNo: row.PANNo,
//                     aadharNo: row.AadharNo,
//                     transporter: row.Transporter,
//                     agentName: row.AgentName,
//                     agentComm: row.AgentCommission === "" ? 0 : parseFloat(row.AgentCommission),
//                     msmeNo: row.MSMENo,
//                     paymentTerms: row.PaymentDays === "" ? 0 : parseFloat(row.PaymentDays),
//                     creditLimit: row.CreditLimit === "" ? 0 : parseFloat(row.CreditLimit),
//                     interest: row.Interest === "" ? 0 : parseFloat(row.Interest),
//                     disc: row.Disc === "" ? 0 : parseFloat(row.Disc),
//                     companyId,
//                     AppRegID,
//                     fYear,
//                     userId,
//                     accGroupId: accGroupId || null,  // ✅ Account group ID from GrpName + SubGrpName
//                     accGroupName: `${row.SubGrpName}[${row.GrpName}]` || ''  // ✅ Account group display name
//                 };

//                 try {
//                     const response = await axios.post(`${path}/client/insert`, payload, {
//                         validateStatus: (status) => [200, 201, 204, 304, 500].includes(status)
//                     });

//                     const status = response.status;
//                     let message = "";

//                     if (status === 201) {
//                         message = "Inserted";
//                         insertedCount++;
//                         insertedRowIds.push(row.id);
//                     } else if (status === 204 || status === 304) {
//                         message = "Already Exists";
//                         existsCount++;
//                     } else {
//                         message = "Failed";
//                         failedCount++;
//                     }

//                     setRowStatus(prev => ({
//                         ...prev,
//                         [row.id]: { status, message }
//                     }));
//                 } catch (err) {
//                     const status = err.response?.status || 500;
//                     setRowStatus(prev => ({
//                         ...prev,
//                         [row.id]: { status, message: "Failed" }
//                     }));
//                     failedCount++;
//                 }

//                 const progress = 50 + Math.round(((i + 1) / validRows.length) * 50);
//                 updateProgress(progress);
//             }

//             const parts = [];
//             if (insertedCount) parts.push(`${insertedCount} Inserted`);
//             if (existsCount) parts.push(`${existsCount} Already Exists`);
//             if (failedCount) parts.push(`${failedCount} Failed`);
//             if (errorRows.length) parts.push(`${errorRows.length} Skipped (errors)`);

//             setSnackbar({
//                 open: true,
//                 message: parts.join(" | "),
//                 severity: insertedCount > 0 ? "success" : "warning"
//             });

//             setTimeout(() => {
//                 const sortedFadeIds = insertedRowIds
//                     .map(id => ({ id, name: data.find(r => r.id === id)?.CompanyName || "" }))
//                     .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
//                     .map(item => item.id);

//                 sortedFadeIds.forEach((id, index) => {
//                     setTimeout(() => {
//                         setFadeOutIds(prev => new Set(prev).add(id));
//                     }, index * 1000);
//                 });

//                 setTimeout(() => {
//                     setData(prev => prev.filter(r => !insertedRowIds.includes(r.id)));
//                     setInsertedIds(new Set());
//                     setFadeOutIds(new Set());
//                     setRowStatus({});
//                 }, sortedFadeIds.length * 1000 + 600);
//             }, 5000);

//         } catch (error) {
//             console.error("Unexpected error:", error);
//             setSnackbar({ open: true, message: "Unexpected error occurred", severity: "error" });
//         } finally {
//             setUploading(false);
//             setShowBuffer(false);
//         }
//     };

//     const handleBackClick = () => { navigate("/main/newClient"); };

//     const sortedData = useMemo(() => {
//         const withError = data.filter(r => (r._missingFields?.length || 0) > 0);
//         const withoutError = data.filter(r => !r._missingFields || r._missingFields.length === 0);

//         const sortedWithoutError = [...withoutError].sort((a, b) => {
//             const nameA = (a.CompanyName || "").trim().toLowerCase();
//             const nameB = (b.CompanyName || "").trim().toLowerCase();
//             return nameA.localeCompare(nameB);
//         });

//         return [...withError, ...sortedWithoutError];
//     }, [data]);

//     const filteredDataFinal = useMemo(() => {
//         let result = sortedData;

//         if (filterMode === 'perfect') {
//             result = result.filter(r => !r._missingFields || r._missingFields.length === 0);
//         } else if (filterMode === 'error') {
//             result = result.filter(r => r._missingFields?.length > 0);
//         }

//         if (searchText.trim()) {
//             const lowerSearch = searchText.toLowerCase();
//             result = result.filter(row =>
//                 row.CompanyName?.toLowerCase().includes(lowerSearch) ||
//                 String(row.GSTNo).toLowerCase().includes(lowerSearch) ||
//                 String(row.MobileNo).toLowerCase().includes(lowerSearch) ||
//                 String(row.EmailId).toLowerCase().includes(lowerSearch)
//             );
//         }

//         return result;
//     }, [sortedData, filterMode, searchText]);

//     useMemo(() => {
//         setFilteredData(filteredDataFinal);
//     }, [filteredDataFinal]);

//     const errorCount = useMemo(() => data.filter(r => r._missingFields?.length > 0).length, [data]);
//     const perfectCount = useMemo(() => data.length - errorCount, [data]);
//     const validRowsCount = useMemo(() => data.filter(r => !r._missingFields || r._missingFields.length === 0).length, [data]);

//     const fieldGroups = [
//         {
//             title: "Company Info",
//             icon: <BusinessIcon fontSize="small" />,
//             fields: [
//                 { label: "GST No.", key: "GSTNo" },
//                 { label: "Company Name", key: "CompanyName" },
//                 { label: "Client Code", key: "ClientCode" },
//                 { label: "Contact Person", key: "ContactPerson" },
//                 { label: "Mobile No.", key: "MobileNo" },
//                 { label: "Email Id", key: "EmailId" },
//             ]
//         },
//         {
//             title: "Account Group",
//             icon: <BusinessIcon fontSize="small" />,
//             fields: [
//                 { label: "Category", key: "CategoryCode" },
//                 { label: "Group Name", key: "GrpName" },
//                 { label: "Sub Group Name", key: "SubGrpName" },
//             ]
//         },
//         {
//             title: "Address",
//             icon: <LocationOnIcon fontSize="small" />,
//             fields: [
//                 { label: "Address", key: "Address" },
//                 { label: "Landmark", key: "Landmark" },
//                 { label: "City", key: "City" },
//                 { label: "State", key: "State" },
//                 { label: "Pincode", key: "Pincode" },
//                 { label: "Country", key: "Country" },
//             ]
//         },
//         {
//             title: "Financial & Agent",
//             icon: <PhoneIcon fontSize="small" />,
//             fields: [
//                 { label: "Agent Name", key: "AgentName" },
//                 { label: "Agent Commission (%)", key: "AgentCommission" },
//                 { label: "Payment Days", key: "PaymentDays" },
//                 { label: "Credit Limit", key: "CreditLimit" },
//                 { label: "Interest (%)", key: "Interest" },
//                 { label: "Discount (%)", key: "Disc" },
//             ]
//         },
//         {
//             title: "Other Details",
//             icon: <EmailIcon fontSize="small" />,
//             fields: [
//                 { label: "Alternate Mobile", key: "AlternateMobileNo" },
//                 { label: "Alternate Email", key: "AlternateEmailId" },
//                 { label: "Website", key: "Website" },
//                 { label: "PAN No.", key: "PANNo" },
//                 { label: "Aadhar No.", key: "AadharNo" },
//                 { label: "MSME No.", key: "MSMENo" },
//                 { label: "Transporter", key: "Transporter" },
//                 { label: "Distance (km)", key: "Distance" },
//                 { label: "State Code", key: "StateCode" },
//             ]
//         }
//     ];

//     return (
//         <Container sx={{ pt: { xs: 1, sm: 2 }, pb: { xs: 1, sm: 2 }, px: { xs: 1, sm: 2 }, maxWidth: { xs: "100%", sm: "100%", md: "1400px" } }}>
//             {/* Header Section with enhanced styling */}
//             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, gap: 2, flexWrap: "wrap" }}>
//                 <Box>
//                     <Typography
//                         variant="h4"
//                         sx={{
//                             fontWeight: 700,
//                             background: "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
//                             backgroundClip: "text",
//                             WebkitBackgroundClip: "text",
//                             WebkitTextFillColor: "transparent",
//                             fontSize: { xs: "1.5rem", sm: "2rem", md: "2.25rem" },
//                             letterSpacing: "-0.5px"
//                         }}
//                     >
//                         Client Data Upload
//                     </Typography>
//                     <Typography
//                         variant="body2"
//                         sx={{
//                             color: "text.secondary",
//                             mt: 0.5,
//                             fontSize: { xs: "0.8rem", sm: "0.95rem" }
//                         }}
//                     >
//                         Manage and import your client information
//                     </Typography>
//                 </Box>
//                 <Tooltip title="Back to Options" placement="left">
//                     <IconButton
//                         onClick={handleBackClick}
//                         sx={{
//                             bgcolor: "#1976d2",
//                             color: "white",
//                             width: { xs: 40, sm: 48 },
//                             height: { xs: 40, sm: 48 },
//                             "&:hover": {
//                                 bgcolor: "#115293",
//                                 transform: "translateY(-2px)",
//                                 boxShadow: "0 6px 16px rgba(25, 118, 210, 0.4)"
//                             },
//                             borderRadius: 1.5,
//                             transition: "all 0.3s ease",
//                             boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
//                             flexShrink: 0
//                         }}
//                     >
//                         <ArrowBackIcon sx={{ fontSize: { xs: 22, sm: 26 } }} />
//                     </IconButton>
//                 </Tooltip>
//             </Box>

//             <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
//                 {/* File Upload Card */}
//                 <Paper sx={{
//                     px: { xs: 3, sm: 3.5 },
//                     py: { xs: 2, sm: 2.5 },
//                     borderRadius: { xs: 2.5, sm: 3 },
//                     bgcolor: "background.paper",
//                     boxShadow: "0 4px 16px rgba(25, 118, 210, 0.4)",
//                     border: `1px solid ${alpha('#1976d2', 0.1)}`,
//                     position: "relative",
//                     overflow: "hidden",
//                     "&::before": {
//                         content: '""',
//                         position: "absolute",
//                         top: 0,
//                         left: 0,
//                         right: 0,
//                         height: 1,
//                         background: `linear-gradient(90deg, transparent, rgba(25, 118, 210, 0.3), transparent)`,
//                     }
//                 }}>
//                     <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
//                         {/* File Upload Zone */}
//                         <FileUploadZone fileInputRef={fileInputRef} file={file} handleFileChange={handleFileChange} data={data} />

//                         {/* Upload Controls & Progress */}
//                         {(file || data.length > 0) && (
//                             <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: { xs: "space-between", sm: "flex-start" } }}>
//                                 <Button
//                                     variant="contained"
//                                     onClick={handleUploadSubmit}
//                                     disabled={uploading || !data.length || validRowsCount === 0}
//                                     sx={{
//                                         height: { xs: 40, sm: 44 },
//                                         bgcolor: "#1976d2",
//                                         "&:hover": {
//                                             bgcolor: "#115293",
//                                             boxShadow: "0 6px 20px rgba(25, 118, 210, 0.4)",
//                                             transform: "translateY(-2px)"
//                                         },
//                                         borderRadius: 1.5,
//                                         textTransform: "none",
//                                         fontWeight: 700,
//                                         px: { xs: 2, sm: 3 },
//                                         "&.Mui-disabled": { bgcolor: "#bdbdbd", color: "#666" },
//                                         fontSize: { xs: "0.95rem", sm: "1.05rem" },
//                                         minWidth: { xs: "auto", sm: 140 },
//                                         transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//                                         boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
//                                         gap: 1
//                                     }}
//                                 >
//                                     {uploading ? <CircularProgress size={22} color="inherit" /> : <InsertDriveFileIcon sx={{ fontSize: 22 }} />}
//                                     {uploading ? "Uploading..." : "Upload Records"}
//                                 </Button>
//                                 {showBuffer && (
//                                     <Box sx={{ width: { xs: "100%", sm: 280 } }}>
//                                         <LinearProgress
//                                             variant="buffer"
//                                             value={progressValue}
//                                             valueBuffer={bufferValue}
//                                             sx={{
//                                                 height: 4,
//                                                 borderRadius: 4,
//                                                 backgroundColor: alpha('#1976d2', 0.1),
//                                                 "& .MuiLinearProgress-bar": {
//                                                     borderRadius: 4,
//                                                     background: "linear-gradient(90deg, #1976d2, #42a5f5)"
//                                                 }
//                                             }}
//                                         />
//                                         <Typography
//                                             variant="caption"
//                                             sx={{
//                                                 display: "block",
//                                                 textAlign: "center",
//                                                 fontSize: { xs: "0.75rem", sm: "0.85rem" },
//                                                 fontWeight: 600,
//                                                 color: "#1976d2"
//                                             }}
//                                         >
//                                             {uploading ? `${Math.round(progressValue)}%` : `Ready`}
//                                         </Typography>
//                                     </Box>
//                                 )}
//                             </Box>
//                         )}

//                         {/* Statistics Chips */}
//                         {data.length > 0 && (
//                             <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", justifyContent: { xs: "center", sm: "flex-end" } }}>
//                                 <Chip
//                                     icon={<CheckCircleIcon sx={{ fontSize: 18 }} />}
//                                     label={`${perfectCount} Valid`}
//                                     onClick={() => setFilterMode(prev => prev === 'perfect' ? 'all' : 'perfect')}
//                                     variant={filterMode === 'perfect' ? "filled" : "outlined"}
//                                     sx={{
//                                         bgcolor: filterMode === 'perfect' ? '#4caf50' : 'transparent',
//                                         color: filterMode === 'perfect' ? 'white' : '#4caf50',
//                                         fontWeight: 700,
//                                         border: filterMode === 'perfect' ? 'none' : '2px solid #4caf50',
//                                         cursor: 'pointer',
//                                         transition: 'all 0.3s ease',
//                                         '&:hover': {
//                                             bgcolor: filterMode === 'perfect' ? '#388e3c' : alpha('#4caf50', 0.08),
//                                             transform: 'translateY(-2px)',
//                                             boxShadow: '0 4px 12px rgba(76, 175, 80, 0.3)'
//                                         },
//                                         fontSize: { xs: "0.8rem", sm: "0.95rem" }
//                                     }}
//                                 />
//                                 <Chip
//                                     icon={<ErrorIcon sx={{ fontSize: 18 }} />}
//                                     label={`${errorCount} Errors`}
//                                     onClick={() => setFilterMode(prev => prev === 'error' ? 'all' : 'error')}
//                                     variant={filterMode === 'error' ? "filled" : "outlined"}
//                                     sx={{
//                                         bgcolor: filterMode === 'error' ? '#f44336' : 'transparent',
//                                         color: filterMode === 'error' ? 'white' : '#f44336',
//                                         fontWeight: 700,
//                                         border: filterMode === 'error' ? 'none' : '2px solid #f44336',
//                                         cursor: 'pointer',
//                                         transition: 'all 0.3s ease',
//                                         '&:hover': {
//                                             bgcolor: filterMode === 'error' ? '#d32f2f' : alpha('#f44336', 0.08),
//                                             transform: 'translateY(-2px)',
//                                             boxShadow: '0 4px 12px rgba(244, 67, 54, 0.3)'
//                                         },
//                                         fontSize: { xs: "0.8rem", sm: "0.95rem" }
//                                     }}
//                                 />
//                             </Box>
//                         )}
//                     </Box>
//                 </Paper>

//                 {/* Data Display Section */}
//                 {data.length > 0 && (
//                     <GlassParentCard>
//                         {/* Search Bar */}
//                         <Box p={{ xs: 1, sm: 1.5 }} pb={1.5}>
//                             <TextField
//                                 fullWidth
//                                 size="small"
//                                 placeholder={isMobile ? "Search companies..." : "Search by company name, phone, email..."}
//                                 value={searchText}
//                                 onChange={(e) => setSearchText(e.target.value)}
//                                 InputProps={{
//                                     startAdornment: (
//                                         <InputAdornment position="start">
//                                             <SearchIcon sx={{ fontSize: 22, color: "#1976d2" }} />
//                                         </InputAdornment>
//                                     ),
//                                 }}
//                                 sx={{
//                                     "& .MuiOutlinedInput-root": {
//                                         borderRadius: 2,
//                                         bgcolor: "background.paper",
//                                         fontSize: { xs: "0.9rem", sm: "1rem" },
//                                         border: `1.5px solid ${alpha('#1976d2', 0.2)}`,
//                                         transition: "all 0.3s ease",
//                                         "&:hover": {
//                                             borderColor: alpha('#1976d2', 0.4)
//                                         },
//                                         "&.Mui-focused": {
//                                             borderColor: "#1976d2",
//                                             boxShadow: `0 0 0 3px ${alpha('#1976d2', 0.1)}`
//                                         }
//                                     }
//                                 }}
//                             />
//                         </Box>

//                         {/* Records Container */}
//                         <Box
//                             flex={1}
//                             overflow="auto"
//                             p={{ xs: 1.5, sm: 2 }}
//                             pt={0}
//                             sx={{
//                                 maxHeight: { xs: "calc(100vh - 380px)", sm: "calc(100vh - 300px)", md: "calc(78vh - 80px)" },
//                                 '&::-webkit-scrollbar': { width: '8px' },
//                                 '&::-webkit-scrollbar-track': { background: alpha('#1976d2', 0.05), borderRadius: '10px' },
//                                 '&::-webkit-scrollbar-thumb': {
//                                     background: '#1976d2',
//                                     borderRadius: '10px',
//                                     '&:hover': { background: '#115293' }
//                                 }
//                             }}
//                         >
//                             <Stack spacing={{ xs: 1.5, sm: 2, md: 2.5 }}>
//                                 {filteredData.length === 0 ? (
//                                     <Paper sx={{
//                                         p: 2.5,
//                                         textAlign: "center",
//                                         borderRadius: 3,
//                                         bgcolor: alpha("#1976d2", 0.02),
//                                         border: `1px dashed ${alpha("#1976d2", 0.2)}`
//                                     }}>
//                                         <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
//                                             <SearchIcon sx={{ fontSize: 48, color: alpha("#1976d2", 0.3), mb: 1 }} />
//                                             <Typography variant="h6" color="text.secondary" sx={{ fontSize: { xs: "1rem", sm: "1.1rem" }, fontWeight: 600 }}>
//                                                 {searchText || filterMode !== 'all' ? "No records match your search" : "No data loaded"}
//                                             </Typography>
//                                         </Box>
//                                     </Paper>
//                                 ) : (
//                                     filteredData.map((r, idx) => {
//                                         const missing = r._missingFields || [];
//                                         const isError = missing.length > 0;
//                                         const expanded = expandedCards[r.id];
//                                         const statusInfo = rowStatus[r.id];
//                                         const isFading = fadeOutIds.has(r.id);

//                                         let cardBg = "background.paper";
//                                         let borderColor = alpha('#1976d2', 0.2);
//                                         let statusChip = null;

//                                         if (statusInfo) {
//                                             if (statusInfo.status === 201) {
//                                                 cardBg = "#e8f5e9";
//                                                 borderColor = "#4caf50";
//                                                 statusChip = { color: "#1b5e20", bg: "#4caf50", icon: <CheckCircleOutlineIcon sx={{ fontSize: 14 }} />, label: "✓ Inserted" };
//                                             } else if ([204, 304].includes(statusInfo.status)) {
//                                                 cardBg = "#fff8e1";
//                                                 borderColor = "#ffb300";
//                                                 statusChip = { color: "#ff8f00", bg: "#ffb300", icon: <WarningIcon sx={{ fontSize: 14 }} />, label: "Already Exists" };
//                                             } else {
//                                                 cardBg = "#ffebee";
//                                                 borderColor = "#f44336";
//                                                 statusChip = { color: "#c62828", bg: "#f44336", icon: <ErrorIcon sx={{ fontSize: 14 }} />, label: "Failed" };
//                                             }
//                                         } else if (isError) {
//                                             cardBg = "#ffebee";
//                                             borderColor = "#f44336";
//                                         }

//                                         return (
//                                             <Card
//                                                 key={r.id}
//                                                 elevation={isError ? 4 : 2}
//                                                 sx={{
//                                                     borderRadius: { xs: 2, sm: 2.5, md: 3 },
//                                                     bgcolor: cardBg,
//                                                     border: `2px solid ${borderColor}`,
//                                                     position: "relative",
//                                                     overflow: "visible",
//                                                     transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
//                                                     opacity: isFading ? 0 : 1,
//                                                     transform: isFading ? "translateY(-20px) scale(0.95)" : "translateY(0)",
//                                                     height: isFading ? 0 : "auto",
//                                                     marginBottom: isFading ? "-10px" : { xs: 1, sm: 2 },
//                                                     padding: isFading ? 0 : { xs: 1, sm: 1.5 },
//                                                     "&:hover": {
//                                                         boxShadow: isError ? "0 12px 28px rgba(244, 67, 54, 0.15)" : "0 12px 28px rgba(25, 118, 210, 0.15)",
//                                                     }
//                                                 }}
//                                             >
//                                                 {statusChip && !isFading && (
//                                                     <Box
//                                                         sx={{
//                                                             position: "absolute",
//                                                             bottom: 8,
//                                                             right: 12,
//                                                             bgcolor: statusChip.bg,
//                                                             color: statusChip.bg === '#ffb300' ? '#000' : 'white',
//                                                             px: 1.25,
//                                                             py: 0.4,
//                                                             borderRadius: 1.5,
//                                                             fontSize: { xs: "0.7rem", sm: "0.8rem" },
//                                                             fontWeight: 700,
//                                                             display: "flex",
//                                                             alignItems: "center",
//                                                             gap: 0.5,
//                                                             zIndex: 1,
//                                                             boxShadow: `0 2px 8px ${alpha(statusChip.bg, 0.3)}`
//                                                         }}
//                                                     >
//                                                         {statusChip.icon}
//                                                         {statusChip.label}
//                                                     </Box>
//                                                 )}

//                                                 <CardContent sx={{ pt: { xs: 2, sm: 2.5 }, pb: statusChip ? { xs: 4, sm: 5 } : { xs: 1.5, sm: 2 }, px: { xs: 1.5, sm: 2.5 } }}>
//                                                     {/* Main Header Row */}
//                                                     <Box
//                                                         sx={{
//                                                             display: 'flex',
//                                                             justifyContent: 'space-between',
//                                                             alignItems: 'flex-start',
//                                                             gap: { xs: 1.5, sm: 2, md: 4 },
//                                                             flexWrap: { xs: "wrap", sm: "nowrap" }
//                                                         }}
//                                                     >
//                                                         {/* Company Info */}
//                                                         <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1.5, sm: 2.5 }, flex: { xs: "0 0 100%", sm: 1 } }}>
//                                                             <Box
//                                                                 sx={{
//                                                                     background: statusInfo?.status === 201 ? "linear-gradient(135deg, #4caf50, #66bb6a)" : (isError ? "linear-gradient(135deg, #f44336, #ef5350)" : "linear-gradient(135deg, #1976d2, #42a5f5)"),
//                                                                     color: "white",
//                                                                     width: { xs: 40, sm: 48 },
//                                                                     height: { xs: 40, sm: 48 },
//                                                                     borderRadius: 2,
//                                                                     display: "flex",
//                                                                     alignItems: "center",
//                                                                     justifyContent: "center",
//                                                                     fontWeight: 700,
//                                                                     flexShrink: 0,
//                                                                     fontSize: { xs: "1.1rem", sm: "1.3rem" },
//                                                                     boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)"
//                                                                 }}
//                                                             >
//                                                                 {r.CompanyName?.[0]?.toUpperCase() || "?"}
//                                                             </Box>
//                                                             <Box sx={{ minWidth: 0, flex: 1 }}>
//                                                                 <Typography
//                                                                     variant="h6"
//                                                                     fontWeight={700}
//                                                                     noWrap
//                                                                     sx={{ fontSize: { xs: "1rem", sm: "1.1rem", md: "1.3rem" }, letterSpacing: "-0.3px" }}
//                                                                 >
//                                                                     {r.CompanyName || "Unnamed"}
//                                                                 </Typography>
//                                                                 <Typography
//                                                                     variant="body2"
//                                                                     color="text.secondary"
//                                                                     noWrap
//                                                                     sx={{ fontSize: { xs: "0.75rem", sm: "0.9rem" }, mt: 0.25 }}
//                                                                 >
//                                                                     {r.ContactPerson || "—"} • {r.MobileNo || "—"}
//                                                                 </Typography>
//                                                             </Box>
//                                                         </Box>

//                                                         {/* Quick Info - Responsive Grid */}
//                                                         <Box
//                                                             sx={{
//                                                                 display: 'grid',
//                                                                 gridTemplateColumns: { xs: "1fr 1fr", sm: "repeat(4, 1fr)" },
//                                                                 gap: { xs: 1.25, sm: 1.75 },
//                                                                 alignItems: 'flex-start',
//                                                                 flex: { xs: "0 0 100%", sm: "auto" },
//                                                                 width: { xs: "100%", sm: "auto" }
//                                                             }}
//                                                         >
//                                                             {[
//                                                                 { label: "GST No.", value: r.GSTNo || "—", key: "GSTNo", icon: "🏛️" },
//                                                                 { label: "Email", value: r.EmailId || "—", key: "EmailId", icon: "✉️" },
//                                                                 { label: "Sub Group", value: r.SubGrpName || "—", key: "SubGrpName", icon: "📂" },
//                                                                 { label: "Location", value: `${r.City || ""}, ${r.State || ""}`.trim() || "—", key: "City", icon: "📍" }
//                                                             ].map((item, i) => {
//                                                                 const hasErr = hasFieldError(r, item.key);
//                                                                 return (
//                                                                     <Box
//                                                                         key={i}
//                                                                         sx={{
//                                                                             bgcolor: hasErr ? alpha('#f44336', 0.08) : alpha('#1976d2', 0.04),
//                                                                             borderRadius: 1.5,
//                                                                             p: 1,
//                                                                             transition: 'all 0.2s ease',
//                                                                             display: 'flex',
//                                                                             flexDirection: 'column',
//                                                                             alignItems: 'flex-start',
//                                                                             minWidth: 0,
//                                                                             border: `1px solid ${hasErr ? alpha('#f44336', 0.2) : alpha('#1976d2', 0.1)}`
//                                                                         }}
//                                                                     >
//                                                                         <Typography
//                                                                             variant="caption"
//                                                                             sx={{
//                                                                                 fontWeight: 700,
//                                                                                 color: hasErr ? '#f44336' : 'text.secondary',
//                                                                                 lineHeight: 1.3,
//                                                                                 fontSize: { xs: "0.7rem", sm: "0.8rem" },
//                                                                                 textTransform: "uppercase",
//                                                                                 letterSpacing: "0.5px"
//                                                                             }}
//                                                                         >
//                                                                             {item.label}
//                                                                         </Typography>
//                                                                         <Typography
//                                                                             variant="body2"
//                                                                             fontWeight={600}
//                                                                             noWrap
//                                                                             sx={{
//                                                                                 mt: 0.4,
//                                                                                 wordBreak: 'break-word',
//                                                                                 maxWidth: '100%',
//                                                                                 fontSize: { xs: "0.75rem", sm: "0.9rem" },
//                                                                                 color: "#000"
//                                                                             }}
//                                                                         >
//                                                                             {item.value}
//                                                                         </Typography>
//                                                                     </Box>
//                                                                 );
//                                                             })}
//                                                         </Box>

//                                                         {/* Expand Button */}
//                                                         <IconButton
//                                                             size="small"
//                                                             onClick={() => toggleExpand(r.id)}
//                                                             sx={{
//                                                                 alignSelf: 'flex-start',
//                                                                 flexShrink: 0,
//                                                                 bgcolor: alpha('#1976d2', 0.1),
//                                                                 color: '#1976d2',
//                                                                 transition: 'all 0.3s ease',
//                                                                 "&:hover": {
//                                                                     bgcolor: alpha('#1976d2', 0.2),
//                                                                     transform: 'scale(1.1)'
//                                                                 }
//                                                             }}
//                                                         >
//                                                             {expanded ? <ExpandLessIcon sx={{ fontSize: { xs: 20, sm: 24 } }} /> : <ExpandMoreIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />}
//                                                         </IconButton>
//                                                     </Box>

//                                                     {/* Expanded Details */}
//                                                     <Collapse in={expanded} timeout="auto" unmountOnExit>
//                                                         <Divider sx={{ my: 1.5 }} />
//                                                         <Box mt={1.5}>
//                                                             {fieldGroups.map((group, gIdx) => (
//                                                                 <Box key={gIdx} mb={2}>
//                                                                     <Typography
//                                                                         variant="subtitle2"
//                                                                         color="primary"
//                                                                         gutterBottom
//                                                                         sx={{
//                                                                             display: "flex",
//                                                                             alignItems: "center",
//                                                                             gap: 0.75,
//                                                                             fontSize: { xs: "0.85rem", sm: "1rem" },
//                                                                             fontWeight: 700,
//                                                                             textTransform: "uppercase",
//                                                                             letterSpacing: "0.5px"
//                                                                         }}
//                                                                     >
//                                                                         {group.icon} {group.title}
//                                                                     </Typography>
//                                                                     <Grid container spacing={{ xs: 1, sm: 1.5 }}>
//                                                                         {group.fields.map((f, fIdx) => (
//                                                                             <Grid item xs={12} sm={6} key={fIdx}>
//                                                                                 <Box sx={{ p: 1, borderRadius: 1.5, bgcolor: alpha('#1976d2', 0.02), border: `1px solid ${alpha('#1976d2', 0.1)}` }}>
//                                                                                     <Typography
//                                                                                         variant="caption"
//                                                                                         sx={{
//                                                                                             color: hasFieldError(r, f.key) ? '#f44336' : 'text.secondary',
//                                                                                             fontWeight: hasFieldError(r, f.key) ? 700 : 600,
//                                                                                             fontSize: { xs: "0.7rem", sm: "0.8rem" },
//                                                                                             textTransform: "uppercase",
//                                                                                             letterSpacing: "0.3px"
//                                                                                         }}
//                                                                                     >
//                                                                                         {f.label}
//                                                                                     </Typography>
//                                                                                     <Typography
//                                                                                         variant="body2"
//                                                                                         fontWeight={600}
//                                                                                         sx={{ fontSize: { xs: "0.8rem", sm: "0.9rem" }, mt: 0.5 }}
//                                                                                     >
//                                                                                         {r[f.key] || "—"}
//                                                                                     </Typography>
//                                                                                 </Box>
//                                                                             </Grid>
//                                                                         ))}
//                                                                     </Grid>
//                                                                 </Box>
//                                                             ))}
//                                                         </Box>
//                                                     </Collapse>
//                                                 </CardContent>
//                                             </Card>
//                                         );
//                                     })
//                                 )}
//                             </Stack>
//                         </Box>
//                     </GlassParentCard>
//                 )}
//             </Box>

//             {/* Snackbar */}
//             <Snackbar
//                 open={snackbar.open}
//                 autoHideDuration={6000}
//                 onClose={() => setSnackbar({ ...snackbar, open: false })}
//                 anchorOrigin={{ vertical: "top", horizontal: "center" }}
//             >
//                 <Alert
//                     onClose={() => setSnackbar({ ...snackbar, open: false })}
//                     severity={snackbar.severity}
//                     sx={{
//                         width: "100%",
//                         fontSize: { xs: "0.85rem", sm: "0.95rem" },
//                         fontWeight: 600,
//                         boxShadow: "0 4px 16px rgba(0, 0, 0, 0.15)"
//                     }}
//                 >
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Container>
//     );
// };

// export default InsertClient;









import React, { useState, useRef, useMemo, useEffect } from "react";
import { Box, Button, Container, Typography, Snackbar, Alert, CircularProgress, LinearProgress, Card, CardContent, Grid, TextField, InputAdornment, Paper, Divider, Stack, IconButton, Collapse, alpha, Chip, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import * as XLSX from "xlsx";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import SearchIcon from '@mui/icons-material/Search';
import BusinessIcon from '@mui/icons-material/Business';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import WarningIcon from '@mui/icons-material/Warning';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useAuth } from '../context/AuthContext';
import { getCurrentFYear } from '../utils/financialYear';

// Simple UUID-like ID generator for unique row IDs
const generateUniqueId = () => {
    return `row-${Math.random().toString(36).substr(2, 9)}-${Date.now().toString(36)}`;
};

// Modern Glass Card with enhanced styling
const GlassParentCard = ({ children }) => (
    <Paper
        elevation={0}
        sx={{
            borderRadius: { xs: 2, sm: 3, md: 4 },
            background: (theme) => `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.95)} 0%, ${alpha(theme.palette.background.paper, 0.85)} 100%)`,
            backdropFilter: "blur(20px)",
            WebKitBackdropFilter: "blur(20px)",
            border: `1px solid ${(theme) => alpha(theme.palette.primary.main, 0.1)}`,
            [`& .MuiPaper-root`]: { borderRadius: { xs: 2, sm: 3 } },
            boxShadow: "0 20px 60px rgba(25, 118, 210, 0.08), 0 0 1px rgba(25, 118, 210, 0.1)",
            position: "relative",
            overflow: "hidden",
            maxHeight: { xs: "calc(100vh - 300px)", sm: "calc(100vh - 250px)", md: "78vh" },
            display: "flex",
            flexDirection: "column",
            "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: 1,
                background: `linear-gradient(90deg, transparent, rgba(25, 118, 210, 0.3), transparent)`,
            },
            "&::after": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: 4,
                height: "100%",
                background: "linear-gradient(180deg, #1976d2, #42a5f5, transparent)",
                borderRadius: "0 8px 8px 0",
            }
        }}
    >
        {children}
    </Paper>
);

// Enhanced File Upload Zone
const FileUploadZone = ({ fileInputRef, file, handleFileChange, data }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [isDragOver, setIsDragOver] = useState(false);

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragOver(true);
    };

    const handleDragLeave = () => {
        setIsDragOver(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragOver(false);
        const droppedFiles = e.dataTransfer.files;
        if (droppedFiles.length > 0) {
            fileInputRef.current.files = droppedFiles;
            const event = new Event('change', { bubbles: true });
            Object.defineProperty(event, 'target', { value: fileInputRef.current, enumerable: true });
            handleFileChange(event);
        }
    };

    return (
        <Box
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            sx={{
                position: "relative",
                borderRadius: { xs: 2, sm: 3 },
                border: `2px dashed ${isDragOver ? '#1976d2' : alpha('#1976d2', 0.3)}`,
                p: { xs: 2, sm: 3 },
                textAlign: "center",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                background: isDragOver ? alpha('#1976d2', 0.05) : alpha('#1976d2', 0.02),
                cursor: "pointer",
                "&:hover": {
                    borderColor: '#1976d2',
                    bgcolor: alpha('#1976d2', 0.04),
                },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: { xs: 120, sm: 140 },
                gap: 2,
            }}
        >
            <input type="file" accept=".xlsx,.xls,.csv" onChange={handleFileChange} ref={fileInputRef} style={{ display: "none" }} id="file-upload" />

            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
                <CloudUploadIcon sx={{ fontSize: { xs: 40, sm: 50 }, color: '#1976d2', opacity: 0.7 }} />
                <Box>
                    <Typography
                        variant="body1"
                        sx={{
                            fontWeight: 600,
                            color: "#1976d2",
                            fontSize: { xs: "0.95rem", sm: "1.1rem" },
                            mb: 0.5
                        }}
                    >
                        {file ? `Selected: ${file.name}` : "Drop your file here or click to browse"}
                    </Typography>
                    <Typography
                        variant="caption"
                        sx={{
                            color: "text.secondary",
                            fontSize: { xs: "0.75rem", sm: "0.875rem" }
                        }}
                    >
                        Excel (.xlsx, .xls) or CSV files only
                    </Typography>
                </Box>
            </Box>

            <Button
                variant="contained"
                onClick={(e) => {
                    e.stopPropagation();
                    const hasError = data.some(r => r._missingFields?.length > 0);
                    if (data.length > 0 && hasError && !window.confirm("There are rows with errors. Are you sure you want to choose a new file?")) {
                        return;
                    }
                    fileInputRef.current.click();
                }}
                sx={{
                    height: { xs: 36, sm: 40 },
                    bgcolor: "#1976d2",
                    "&:hover": { bgcolor: "#115293" },
                    borderRadius: 1.5,
                    textTransform: "none",
                    fontWeight: 600,
                    px: { xs: 2, sm: 2.5 },
                    whiteSpace: "nowrap",
                    fontSize: { xs: "0.85rem", sm: "0.95rem" },
                    boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                        bgcolor: "#115293",
                        boxShadow: "0 6px 16px rgba(25, 118, 210, 0.4)",
                        transform: "translateY(-2px)"
                    }
                }}
            >
                Browse
            </Button>
        </Box>
    );
};

const InsertClient = ({ connectionString }) => {
    const { user, selectedCompany, loading } = useAuth();
    const path = connectionString;
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const fileInputRef = useRef(null);
    const [file, setFile] = useState(null);
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [progressValue, setProgressValue] = useState(0);
    const [bufferValue, setBufferValue] = useState(0);
    const [showBuffer, setShowBuffer] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    const [searchText, setSearchText] = useState("");
    const [expandedCards, setExpandedCards] = useState({});
    const [filterMode, setFilterMode] = useState('all');
    const [clientCategory, setClientCategory] = useState("");
    const [insertedIds, setInsertedIds] = useState(new Set());
    const [fadeOutIds, setFadeOutIds] = useState(new Set());
    const [rowStatus, setRowStatus] = useState({});
    const [accGroups, setAccGroups] = useState([]);

    const toggleExpand = (id) => setExpandedCards(prev => ({ ...prev, [id]: !prev[id] }));
    const clientCategoryOptions = [{ display: "Bank Receipt", value: "Br" }, { display: "Cash Receipt", value: "Cr" }];

    console.log("InsertClient props:", { user, selectedCompany, connectionString });

    const companyId = selectedCompany?.CompId || null;
    const fYear = getCurrentFYear();
    const userId = user?.UserId || null;
    const AppRegID = selectedCompany?.AppRegID || null;

    const isSubGroupExists = (subGrpName) => {
        if (!subGrpName || !accGroups.length) return false;

        return accGroups.some(
            ag =>
                ag.SubGrpName?.trim().toLowerCase() ===
                String(subGrpName).trim().toLowerCase()
        );
    };

    const checkCategoryDuplicate = async (categoryName) => {
        try {
            const categoryId = getCategoryId(categoryName);

            if (!categoryName || categoryId == null) {
                return false;
            }

            const res = await axios.get(
                `${path}/client/check-category`,
                {
                    params: {
                        companyId,
                        categoryId
                    }
                }
            );

            // 200 means not duplicate
            return res.data?.duplicate === true;

        } catch (err) {

            // 400 means duplicate
            if (err?.response?.status === 400) {
                return true;
            }

            console.error("Category validation failed:", err);

            // API failure should not mark duplicate
            return false;
        }
    };

    const categoryOptions = [
        { id: 0, value: "---NONE---" },
        { id: 1, value: "LOCAL" },
        { id: 2, value: "INTER-STATE" },
        { id: 3, value: "BANK/CASH/REGISTER" },
        { id: 6, value: "CGST" },
        { id: 7, value: "SGST" },
        { id: 8, value: "IGST" },
        { id: 9, value: "UTGST" },
        { id: 10, value: "CESS" },
        { id: 11, value: "ROUNDOFF" },
        { id: 12, value: "RCM CGST" },
        { id: 13, value: "RCM SGST" },
        { id: 14, value: "RCM IGST" },
        { id: 15, value: "RCM UTGST" },
        { id: 16, value: "RCM GSTCESS" },
        { id: 17, value: "AGENT" },
        { id: 18, value: "TCS" },
        { id: 19, value: "TDS" }
    ];

    const getCategoryId = (excelValue) => {
        if (!excelValue) return null;

        const normalized = String(excelValue)
            .trim()
            .replace(/\s+/g, " ")
            .toUpperCase();

        const found = categoryOptions.find(
            c => c.value.toUpperCase() === normalized
        );

        return found ? found.id : null;
    };

    // ✅ Helper function to find account group ID by GrpName and SubGrpName
    const getAccGroupIdByGroupAndSubGroup = (grpName, subGrpName) => {
        if (!grpName || !subGrpName || !accGroups.length) return null;
        const group = accGroups.find(
            ag => (ag.GrpName?.toLowerCase() === String(grpName).trim().toLowerCase() &&
                ag.SubGrpName?.toLowerCase() === String(subGrpName).trim().toLowerCase()) ||
                (ag.GroupName?.toLowerCase() === String(grpName).trim().toLowerCase() &&
                    ag.AccGroupName?.toLowerCase() === String(subGrpName).trim().toLowerCase())
        );
        return group ? group.AccGrpID || group.id : null;
    };

    // ✅ Fetch account groups on mount
    useEffect(() => {
        const Hlp_Fn_AccUnderGroup = async () => {
            try {
                const { data } = await axios.get(`${path}/api/client-get-data/api/AccUnderGroup`, {
                    params: { companyId },
                    headers: { "Cache-Control": "no-cache" }
                });
                const remapped = (data || []).map(item => ({
                    ...item,
                    displayLabel: `${item.SubGrpName || item.AccGroupName || ''}[${item.GrpName || item.GroupName || ''}]`
                }));
                setAccGroups(remapped || []);
            } catch (err) {
                if (err?.response?.status === 404) {
                    setAccGroups([]);
                } else {
                    console.error(err);
                }
            }
        };
        if (companyId) {
            Hlp_Fn_AccUnderGroup();
        }
    }, [companyId, path]);

    const updateProgress = (value) => {
        const clipped = Math.max(0, Math.min(100, value));
        setProgressValue(clipped);
        setBufferValue(Math.min(100, clipped + 10));
    };

    // Helper to check if a field has an error
    const hasFieldError = (record, fieldKey) => {
        if (!record._missingFields) return false;
        const fieldMap = {
            GSTNo: "GST No.",
            CompanyName: "Company Name",
            CategoryCode: "Category",
            ClientCategory: "Client Category",
            ClientCode: "Client Code",
            GrpName: "GrpName",
            SubGrpName: "SubGrpName",
            Address: "Address",
            Landmark: "Landmark",
            Pincode: "Pincode",
            City: "City",
            State: "State",
            StateCode: "State Code",
            Country: "Country",
            Distance: "Distance",
            ContactPerson: "Contact Person",
            MobileNo: "Mobile No.",
            AlternateMobileNo: "Alt Mobile",
            EmailId: "Email Id",
            AlternateEmailId: "Alternate Email",
            Website: "Website",
            PANNo: "PAN No.",
            AadharNo: "Aadhar No.",
            MSMENo: "MSME No.",
            Transporter: "Transporter",
            AgentName: "Agent Name",
            AgentCommission: "Agent Commission (%)",
            PaymentDays: "Payment Days",
            CreditLimit: "Credit Limit",
            Interest: "Interest (%)",
            Disc: "Discount (%)"
        };
        const errorLabel = fieldMap[fieldKey];
        return errorLabel
            ? record._missingFields.some(
                err =>
                    err.includes(errorLabel) ||
                    (fieldKey === "SubGrpName" &&
                        err.includes("First enter SubGroupName"))
            )
            : false;
    };

    useEffect(() => {
        const hasRedError = data.some(r => r._missingFields?.length > 0);
        const handleBeforeUnload = (e) => {
            if (hasRedError && data.length > 0) {
                e.preventDefault();
                e.returnValue = '';
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [data]);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            const validExtensions = [".xlsx", ".xls", ".csv"];
            const fileExtension = selectedFile.name.slice(selectedFile.name.lastIndexOf(".")).toLowerCase();
            if (!validExtensions.includes(fileExtension)) {
                setSnackbar({ open: true, message: "Only Excel (.xlsx, .xls) or CSV (.csv) files are allowed", severity: "error" });
                setFile(null);
                setData([]);
                setFilteredData([]);
                fileInputRef.current.value = "";
                return;
            }

            setFile(selectedFile);
            fileInputRef.current.value = null;

            // Reset all states
            setData([]);
            setFilteredData([]);
            setRowStatus({});
            setFadeOutIds(new Set());
            setShowBuffer(true);
            setFilterMode('all');
            updateProgress(3);

            // Clone file to force fresh read
            const clonedFile = new File([selectedFile], selectedFile.name, { type: selectedFile.type });
            processFile(clonedFile);
        }
    };

    const processFile = (file) => {
        const reader = new FileReader();

        reader.onprogress = (e) => {
            if (e.lengthComputable) {
                const percentRead = Math.round((e.loaded / e.total) * 100);
                const mapped = Math.round(percentRead * 0.5);
                updateProgress(mapped);
            }
        };

        reader.onload = async (e) => {
            try {
                const binaryData = e.target.result;
                const workbook = XLSX.read(binaryData, { type: "binary" });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

                const headers = jsonData[0] || [];

                // ✅ Build dynamic header index map (column name → index)
                const headerIndexMap = {};
                headers.forEach((h, i) => {
                    if (h) headerIndexMap[String(h).trim()] = i;
                });

                // ✅ Only required columns must exist in file
                const requiredColumns = ["CompanyName", "GrpName", "SubGrpName", "CategoryCode"];
                const missingColumns = requiredColumns.filter(col => headerIndexMap[col] === undefined);
                if (missingColumns.length > 0) {
                    setSnackbar({
                        open: true,
                        message: `Missing required columns: ${missingColumns.join(", ")}`,
                        severity: "error"
                    });
                    setData([]);
                    setFilteredData([]);
                    updateProgress(0);
                    setShowBuffer(false);
                    return;
                }

                // ✅ Required fields from Excel (orange background)
                const requiredFields = [
                    { key: 'CompanyName', label: 'Company Name' },
                    { key: 'CategoryCode', label: 'Category' },
                    { key: 'GrpName', label: 'GrpName' },
                    { key: 'SubGrpName', label: 'SubGrpName' }
                ];

                const parsedData = (
                    await Promise.all(
                        jsonData.slice(1).map(async (row) => {

                            // ✅ Helper to get value by column name dynamically
                            const getVal = (colName) => {
                                const idx = headerIndexMap[colName];
                                return idx !== undefined ? String(row[idx] ?? "") : "";
                            };

                            const record = {
                                id: generateUniqueId(),
                                GSTNo: getVal("GSTNo"),
                                CompanyName: getVal("CompanyName"),
                                CategoryCode: getVal("CategoryCode"),
                                ClientCategory: getVal("ClientCategory"),
                                ClientCode: getVal("ClientCode"),
                                GrpName: getVal("GrpName"),
                                SubGrpName: getVal("SubGrpName"),
                                Address: getVal("Address"),
                                Landmark: getVal("Landmark"),
                                Pincode: getVal("Pincode"),
                                City: getVal("City"),
                                State: getVal("State"),
                                StateCode: getVal("StateCode"),
                                Country: getVal("Country"),
                                Distance: getVal("Distance"),
                                ContactPerson: getVal("ContactPerson"),
                                MobileNo: getVal("MobileNo"),
                                AlternateMobileNo: getVal("AlternateMobileNo"),
                                EmailId: getVal("EmailId"),
                                AlternateEmailId: getVal("AlternateEmailId"),
                                Website: getVal("Website"),
                                PANNo: getVal("PANNo"),
                                AadharNo: getVal("AadharNo"),
                                MSMENo: getVal("MSMENo"),
                                Transporter: getVal("Transporter"),
                                AgentName: getVal("AgentName"),
                                AgentCommission: getVal("AgentCommission"),
                                PaymentDays: getVal("PaymentDays"),
                                CreditLimit: getVal("CreditLimit"),
                                Interest: getVal("Interest"),
                                Disc: getVal("Disc"),
                            };

                            const missing = requiredFields
                                .filter(f => !record[f.key] || String(record[f.key]).trim() === '')
                                .map(f => f.label);

                            const validationErrors = [];

                            if (
                                record.SubGrpName &&
                                !isSubGroupExists(record.SubGrpName)
                            ) {
                                validationErrors.push(
                                    "First enter SubGroupName from AccountGroup Master"
                                );
                            }

                            if (record.GSTNo && record.GSTNo.trim().length !== 15) {
                                validationErrors.push("GST No. must be 15 characters");
                            }

                            const pincodeStr = record.Pincode?.toString().trim();
                            if (pincodeStr && (!/^\d{6}$/.test(pincodeStr))) {
                                validationErrors.push("Pincode must be 6 digits");
                            }

                            const mobileStr = record.MobileNo?.toString().trim();
                            if (mobileStr && !/^\d{10}$/.test(mobileStr)) {
                                validationErrors.push("Mobile No. must be 10 digits");
                            }

                            const altMobileStr = record.AlternateMobileNo?.toString().trim();
                            if (altMobileStr && !/^\d{10}$/.test(altMobileStr)) {
                                validationErrors.push("Alt Mobile must be 10 digits");
                            }

                            const aadharStr = record.AadharNo?.toString().trim();
                            if (aadharStr && !/^\d{12}$/.test(aadharStr)) {
                                validationErrors.push("Aadhar No. must be 12 digits");
                            }

                            if (
                                record.CategoryCode &&
                                getCategoryId(record.CategoryCode) == null &&
                                record.CategoryCode.trim().toUpperCase() !== "---NONE---"
                            ) {
                                validationErrors.push(
                                    `Invalid Category: ${record.CategoryCode}`
                                );
                            }

                            // Same category duplicate logic untouched
                            if (
                                record.CategoryCode &&
                                getCategoryId(record.CategoryCode) !== 0
                            ) {
                                const isDuplicate = await checkCategoryDuplicate(
                                    record.CategoryCode
                                );

                                if (isDuplicate) {
                                    validationErrors.push(
                                        `Category already exists: ${record.CategoryCode}`
                                    );
                                }
                            }

                            record._missingFields = [
                                ...missing,
                                ...validationErrors
                            ];

                            return record;
                        })
                    )
                ).filter(row =>
                    row.CompanyName ||
                    row.ContactPerson ||
                    row.MobileNo ||
                    row.EmailId
                );

                setData(parsedData);
                setFilteredData(parsedData);
                setInsertedIds(new Set());
                setFadeOutIds(new Set());
                setRowStatus({});

                updateProgress(50);
                setSnackbar({ open: true, message: `Successfully parsed ${parsedData.length} records`, severity: "success" });

                updateProgress(100);
                setTimeout(() => {
                    setShowBuffer(false);
                    updateProgress(0);
                }, 800);
            } catch (err) {
                console.error(err);
                setSnackbar({ open: true, message: "Error parsing file", severity: "error" });
                setData([]);
                setFilteredData([]);
                updateProgress(0);
                setShowBuffer(false);
            }
        };

        reader.onerror = () => {
            setSnackbar({ open: true, message: "Error reading file", severity: "error" });
            setData([]);
            setFilteredData([]);
            updateProgress(0);
            setShowBuffer(false);
        };

        reader.readAsBinaryString(file);
    };

    const handleUploadSubmit = async () => {
        if (!data.length) {
            setSnackbar({ open: true, message: "No data to upload", severity: "error" });
            return;
        }

        const validRows = data.filter(r => !r._missingFields || r._missingFields.length === 0);
        const errorRows = data.filter(r => r._missingFields?.length > 0);

        if (validRows.length === 0) {
            setSnackbar({ open: true, message: "All rows contain errors – nothing to insert", severity: "error" });
            return;
        }

        if (!companyId || !userId) {
            setSnackbar({ open: true, message: "Missing company/user data", severity: "error" });
            return;
        }

        setUploading(true);
        setShowBuffer(true);
        updateProgress(0);

        let insertedCount = 0;
        let existsCount = 0;
        let failedCount = 0;
        const clientCategoryValue = clientCategoryOptions.find(option => option.display === clientCategory)?.value || "";

        const insertedRowIds = [];

        try {
            for (let i = 0; i < validRows.length; i++) {
                const row = validRows[i];

                // ✅ Get account group ID using GrpName and SubGrpName
                const accGroupId = getAccGroupIdByGroupAndSubGroup(row.GrpName, row.SubGrpName);

                const payload = {
                    gstNo: row.GSTNo,
                    companyName: row.CompanyName,
                    clientCode: row.ClientCode,
                    clientCategory: clientCategoryValue,
                    categoryId: getCategoryId(row.CategoryCode),
                    address: row.Address,
                    area: row.Landmark,
                    pinCode: row.Pincode,
                    city: row.City,
                    state: row.State,
                    stateCode: row.StateCode,
                    country: row.Country,
                    distance: row.Distance === "" ? 0 : parseFloat(row.Distance),
                    contactPerson: row.ContactPerson,
                    mobileNo: row.MobileNo,
                    alternateMobile: row.AlternateMobileNo,
                    emailId: row.EmailId,
                    alternateEmailId: row.AlternateEmailId,
                    website: row.Website,
                    panNo: row.PANNo,
                    aadharNo: row.AadharNo,
                    transporter: row.Transporter,
                    agentName: row.AgentName,
                    agentComm: row.AgentCommission === "" ? 0 : parseFloat(row.AgentCommission),
                    msmeNo: row.MSMENo,
                    paymentTerms: row.PaymentDays === "" ? 0 : parseFloat(row.PaymentDays),
                    creditLimit: row.CreditLimit === "" ? 0 : parseFloat(row.CreditLimit),
                    interest: row.Interest === "" ? 0 : parseFloat(row.Interest),
                    disc: row.Disc === "" ? 0 : parseFloat(row.Disc),
                    companyId,
                    AppRegID,
                    fYear,
                    userId,
                    accGroupId: accGroupId || null,
                    accGroupName: `${row.SubGrpName}[${row.GrpName}]` || ''
                };

                try {
                    const response = await axios.post(`${path}/client/insert`, payload, {
                        validateStatus: (status) => [200, 201, 204, 304, 500].includes(status)
                    });

                    const status = response.status;
                    let message = "";

                    if (status === 201) {
                        message = "Inserted";
                        insertedCount++;
                        insertedRowIds.push(row.id);
                    } else if (status === 204 || status === 304) {
                        message = "Already Exists";
                        existsCount++;
                    } else {
                        message = "Failed";
                        failedCount++;
                    }

                    setRowStatus(prev => ({
                        ...prev,
                        [row.id]: { status, message }
                    }));
                } catch (err) {
                    const status = err.response?.status || 500;
                    setRowStatus(prev => ({
                        ...prev,
                        [row.id]: { status, message: "Failed" }
                    }));
                    failedCount++;
                }

                const progress = 50 + Math.round(((i + 1) / validRows.length) * 50);
                updateProgress(progress);
            }

            const parts = [];
            if (insertedCount) parts.push(`${insertedCount} Inserted`);
            if (existsCount) parts.push(`${existsCount} Already Exists`);
            if (failedCount) parts.push(`${failedCount} Failed`);
            if (errorRows.length) parts.push(`${errorRows.length} Skipped (errors)`);

            setSnackbar({
                open: true,
                message: parts.join(" | "),
                severity: insertedCount > 0 ? "success" : "warning"
            });

            setTimeout(() => {
                const sortedFadeIds = insertedRowIds
                    .map(id => ({ id, name: data.find(r => r.id === id)?.CompanyName || "" }))
                    .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
                    .map(item => item.id);

                sortedFadeIds.forEach((id, index) => {
                    setTimeout(() => {
                        setFadeOutIds(prev => new Set(prev).add(id));
                    }, index * 1000);
                });

                setTimeout(() => {
                    setData(prev => prev.filter(r => !insertedRowIds.includes(r.id)));
                    setInsertedIds(new Set());
                    setFadeOutIds(new Set());
                    setRowStatus({});
                }, sortedFadeIds.length * 1000 + 600);
            }, 5000);

        } catch (error) {
            console.error("Unexpected error:", error);
            setSnackbar({ open: true, message: "Unexpected error occurred", severity: "error" });
        } finally {
            setUploading(false);
            setShowBuffer(false);
        }
    };

    const handleBackClick = () => { navigate("/main/newClient"); };

    const sortedData = useMemo(() => {
        const withError = data.filter(r => (r._missingFields?.length || 0) > 0);
        const withoutError = data.filter(r => !r._missingFields || r._missingFields.length === 0);

        const sortedWithoutError = [...withoutError].sort((a, b) => {
            const nameA = (a.CompanyName || "").trim().toLowerCase();
            const nameB = (b.CompanyName || "").trim().toLowerCase();
            return nameA.localeCompare(nameB);
        });

        return [...withError, ...sortedWithoutError];
    }, [data]);

    const filteredDataFinal = useMemo(() => {
        let result = sortedData;

        if (filterMode === 'perfect') {
            result = result.filter(r => !r._missingFields || r._missingFields.length === 0);
        } else if (filterMode === 'error') {
            result = result.filter(r => r._missingFields?.length > 0);
        }

        if (searchText.trim()) {
            const lowerSearch = searchText.toLowerCase();
            result = result.filter(row =>
                row.CompanyName?.toLowerCase().includes(lowerSearch) ||
                String(row.GSTNo).toLowerCase().includes(lowerSearch) ||
                String(row.MobileNo).toLowerCase().includes(lowerSearch) ||
                String(row.EmailId).toLowerCase().includes(lowerSearch)
            );
        }

        return result;
    }, [sortedData, filterMode, searchText]);

    useMemo(() => {
        setFilteredData(filteredDataFinal);
    }, [filteredDataFinal]);

    const errorCount = useMemo(() => data.filter(r => r._missingFields?.length > 0).length, [data]);
    const perfectCount = useMemo(() => data.length - errorCount, [data]);
    const validRowsCount = useMemo(() => data.filter(r => !r._missingFields || r._missingFields.length === 0).length, [data]);

    const fieldGroups = [
        {
            title: "Company Info",
            icon: <BusinessIcon fontSize="small" />,
            fields: [
                { label: "GST No.", key: "GSTNo" },
                { label: "Company Name", key: "CompanyName" },
                { label: "Client Code", key: "ClientCode" },
                { label: "Contact Person", key: "ContactPerson" },
                { label: "Mobile No.", key: "MobileNo" },
                { label: "Email Id", key: "EmailId" },
            ]
        },
        {
            title: "Account Group",
            icon: <BusinessIcon fontSize="small" />,
            fields: [
                { label: "Category", key: "CategoryCode" },
                { label: "Group Name", key: "GrpName" },
                { label: "Sub Group Name", key: "SubGrpName" },
            ]
        },
        {
            title: "Address",
            icon: <LocationOnIcon fontSize="small" />,
            fields: [
                { label: "Address", key: "Address" },
                { label: "Landmark", key: "Landmark" },
                { label: "City", key: "City" },
                { label: "State", key: "State" },
                { label: "Pincode", key: "Pincode" },
                { label: "Country", key: "Country" },
            ]
        },
        {
            title: "Financial & Agent",
            icon: <PhoneIcon fontSize="small" />,
            fields: [
                { label: "Agent Name", key: "AgentName" },
                { label: "Agent Commission (%)", key: "AgentCommission" },
                { label: "Payment Days", key: "PaymentDays" },
                { label: "Credit Limit", key: "CreditLimit" },
                { label: "Interest (%)", key: "Interest" },
                { label: "Discount (%)", key: "Disc" },
            ]
        },
        {
            title: "Other Details",
            icon: <EmailIcon fontSize="small" />,
            fields: [
                { label: "Alternate Mobile", key: "AlternateMobileNo" },
                { label: "Alternate Email", key: "AlternateEmailId" },
                { label: "Website", key: "Website" },
                { label: "PAN No.", key: "PANNo" },
                { label: "Aadhar No.", key: "AadharNo" },
                { label: "MSME No.", key: "MSMENo" },
                { label: "Transporter", key: "Transporter" },
                { label: "Distance (km)", key: "Distance" },
                { label: "State Code", key: "StateCode" },
            ]
        }
    ];

    return (
        <Container sx={{ pt: { xs: 1, sm: 2 }, pb: { xs: 1, sm: 2 }, px: { xs: 1, sm: 2 }, maxWidth: { xs: "100%", sm: "100%", md: "1400px" } }}>
            {/* Header Section with enhanced styling */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, gap: 2, flexWrap: "wrap" }}>
                <Box>
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 700,
                            background: "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
                            backgroundClip: "text",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            fontSize: { xs: "1.5rem", sm: "2rem", md: "2.25rem" },
                            letterSpacing: "-0.5px"
                        }}
                    >
                        Client Data Upload
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: "text.secondary",
                            mt: 0.5,
                            fontSize: { xs: "0.8rem", sm: "0.95rem" }
                        }}
                    >
                        Manage and import your client information
                    </Typography>
                </Box>
                <Tooltip title="Back to Options" placement="left">
                    <IconButton
                        onClick={handleBackClick}
                        sx={{
                            bgcolor: "#1976d2",
                            color: "white",
                            width: { xs: 40, sm: 48 },
                            height: { xs: 40, sm: 48 },
                            "&:hover": {
                                bgcolor: "#115293",
                                transform: "translateY(-2px)",
                                boxShadow: "0 6px 16px rgba(25, 118, 210, 0.4)"
                            },
                            borderRadius: 1.5,
                            transition: "all 0.3s ease",
                            boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
                            flexShrink: 0
                        }}
                    >
                        <ArrowBackIcon sx={{ fontSize: { xs: 22, sm: 26 } }} />
                    </IconButton>
                </Tooltip>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                {/* File Upload Card */}
                <Paper sx={{
                    px: { xs: 3, sm: 3.5 },
                    py: { xs: 2, sm: 2.5 },
                    borderRadius: { xs: 2.5, sm: 3 },
                    bgcolor: "background.paper",
                    boxShadow: "0 4px 16px rgba(25, 118, 210, 0.4)",
                    border: `1px solid ${alpha('#1976d2', 0.1)}`,
                    position: "relative",
                    overflow: "hidden",
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        height: 1,
                        background: `linear-gradient(90deg, transparent, rgba(25, 118, 210, 0.3), transparent)`,
                    }
                }}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        {/* File Upload Zone */}
                        <FileUploadZone fileInputRef={fileInputRef} file={file} handleFileChange={handleFileChange} data={data} />

                        {/* Upload Controls & Progress */}
                        {(file || data.length > 0) && (
                            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: { xs: "space-between", sm: "flex-start" } }}>
                                <Button
                                    variant="contained"
                                    onClick={handleUploadSubmit}
                                    disabled={uploading || !data.length || validRowsCount === 0}
                                    sx={{
                                        height: { xs: 40, sm: 44 },
                                        bgcolor: "#1976d2",
                                        "&:hover": {
                                            bgcolor: "#115293",
                                            boxShadow: "0 6px 20px rgba(25, 118, 210, 0.4)",
                                            transform: "translateY(-2px)"
                                        },
                                        borderRadius: 1.5,
                                        textTransform: "none",
                                        fontWeight: 700,
                                        px: { xs: 2, sm: 3 },
                                        "&.Mui-disabled": { bgcolor: "#bdbdbd", color: "#666" },
                                        fontSize: { xs: "0.95rem", sm: "1.05rem" },
                                        minWidth: { xs: "auto", sm: 140 },
                                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                        boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
                                        gap: 1
                                    }}
                                >
                                    {uploading ? <CircularProgress size={22} color="inherit" /> : <InsertDriveFileIcon sx={{ fontSize: 22 }} />}
                                    {uploading ? "Uploading..." : "Upload Records"}
                                </Button>
                                {showBuffer && (
                                    <Box sx={{ width: { xs: "100%", sm: 280 } }}>
                                        <LinearProgress
                                            variant="buffer"
                                            value={progressValue}
                                            valueBuffer={bufferValue}
                                            sx={{
                                                height: 4,
                                                borderRadius: 4,
                                                backgroundColor: alpha('#1976d2', 0.1),
                                                "& .MuiLinearProgress-bar": {
                                                    borderRadius: 4,
                                                    background: "linear-gradient(90deg, #1976d2, #42a5f5)"
                                                }
                                            }}
                                        />
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                display: "block",
                                                textAlign: "center",
                                                fontSize: { xs: "0.75rem", sm: "0.85rem" },
                                                fontWeight: 600,
                                                color: "#1976d2"
                                            }}
                                        >
                                            {uploading ? `${Math.round(progressValue)}%` : `Ready`}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        )}

                        {/* Statistics Chips */}
                        {data.length > 0 && (
                            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", justifyContent: { xs: "center", sm: "flex-end" } }}>
                                <Chip
                                    icon={<CheckCircleIcon sx={{ fontSize: 18 }} />}
                                    label={`${perfectCount} Valid`}
                                    onClick={() => setFilterMode(prev => prev === 'perfect' ? 'all' : 'perfect')}
                                    variant={filterMode === 'perfect' ? "filled" : "outlined"}
                                    sx={{
                                        bgcolor: filterMode === 'perfect' ? '#4caf50' : 'transparent',
                                        color: filterMode === 'perfect' ? 'white' : '#4caf50',
                                        fontWeight: 700,
                                        border: filterMode === 'perfect' ? 'none' : '2px solid #4caf50',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            bgcolor: filterMode === 'perfect' ? '#388e3c' : alpha('#4caf50', 0.08),
                                            transform: 'translateY(-2px)',
                                            boxShadow: '0 4px 12px rgba(76, 175, 80, 0.3)'
                                        },
                                        fontSize: { xs: "0.8rem", sm: "0.95rem" }
                                    }}
                                />
                                <Chip
                                    icon={<ErrorIcon sx={{ fontSize: 18 }} />}
                                    label={`${errorCount} Errors`}
                                    onClick={() => setFilterMode(prev => prev === 'error' ? 'all' : 'error')}
                                    variant={filterMode === 'error' ? "filled" : "outlined"}
                                    sx={{
                                        bgcolor: filterMode === 'error' ? '#f44336' : 'transparent',
                                        color: filterMode === 'error' ? 'white' : '#f44336',
                                        fontWeight: 700,
                                        border: filterMode === 'error' ? 'none' : '2px solid #f44336',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            bgcolor: filterMode === 'error' ? '#d32f2f' : alpha('#f44336', 0.08),
                                            transform: 'translateY(-2px)',
                                            boxShadow: '0 4px 12px rgba(244, 67, 54, 0.3)'
                                        },
                                        fontSize: { xs: "0.8rem", sm: "0.95rem" }
                                    }}
                                />
                            </Box>
                        )}
                    </Box>
                </Paper>

                {/* Data Display Section */}
                {data.length > 0 && (
                    <GlassParentCard>
                        {/* Search Bar */}
                        <Box p={{ xs: 1, sm: 1.5 }} pb={1.5}>
                            <TextField
                                fullWidth
                                size="small"
                                placeholder={isMobile ? "Search companies..." : "Search by company name, phone, email..."}
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon sx={{ fontSize: 22, color: "#1976d2" }} />
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: 2,
                                        bgcolor: "background.paper",
                                        fontSize: { xs: "0.9rem", sm: "1rem" },
                                        border: `1.5px solid ${alpha('#1976d2', 0.2)}`,
                                        transition: "all 0.3s ease",
                                        "&:hover": {
                                            borderColor: alpha('#1976d2', 0.4)
                                        },
                                        "&.Mui-focused": {
                                            borderColor: "#1976d2",
                                            boxShadow: `0 0 0 3px ${alpha('#1976d2', 0.1)}`
                                        }
                                    }
                                }}
                            />
                        </Box>

                        {/* Records Container */}
                        <Box
                            flex={1}
                            overflow="auto"
                            p={{ xs: 1.5, sm: 2 }}
                            pt={0}
                            sx={{
                                maxHeight: { xs: "calc(100vh - 380px)", sm: "calc(100vh - 300px)", md: "calc(78vh - 80px)" },
                                '&::-webkit-scrollbar': { width: '8px' },
                                '&::-webkit-scrollbar-track': { background: alpha('#1976d2', 0.05), borderRadius: '10px' },
                                '&::-webkit-scrollbar-thumb': {
                                    background: '#1976d2',
                                    borderRadius: '10px',
                                    '&:hover': { background: '#115293' }
                                }
                            }}
                        >
                            <Stack spacing={{ xs: 1.5, sm: 2, md: 2.5 }}>
                                {filteredData.length === 0 ? (
                                    <Paper sx={{
                                        p: 2.5,
                                        textAlign: "center",
                                        borderRadius: 3,
                                        bgcolor: alpha("#1976d2", 0.02),
                                        border: `1px dashed ${alpha("#1976d2", 0.2)}`
                                    }}>
                                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
                                            <SearchIcon sx={{ fontSize: 48, color: alpha("#1976d2", 0.3), mb: 1 }} />
                                            <Typography variant="h6" color="text.secondary" sx={{ fontSize: { xs: "1rem", sm: "1.1rem" }, fontWeight: 600 }}>
                                                {searchText || filterMode !== 'all' ? "No records match your search" : "No data loaded"}
                                            </Typography>
                                        </Box>
                                    </Paper>
                                ) : (
                                    filteredData.map((r, idx) => {
                                        const missing = r._missingFields || [];
                                        const isError = missing.length > 0;
                                        const expanded = expandedCards[r.id];
                                        const statusInfo = rowStatus[r.id];
                                        const isFading = fadeOutIds.has(r.id);

                                        let cardBg = "background.paper";
                                        let borderColor = alpha('#1976d2', 0.2);
                                        let statusChip = null;

                                        if (statusInfo) {
                                            if (statusInfo.status === 201) {
                                                cardBg = "#e8f5e9";
                                                borderColor = "#4caf50";
                                                statusChip = { color: "#1b5e20", bg: "#4caf50", icon: <CheckCircleOutlineIcon sx={{ fontSize: 14 }} />, label: "✓ Inserted" };
                                            } else if ([204, 304].includes(statusInfo.status)) {
                                                cardBg = "#fff8e1";
                                                borderColor = "#ffb300";
                                                statusChip = { color: "#ff8f00", bg: "#ffb300", icon: <WarningIcon sx={{ fontSize: 14 }} />, label: "Already Exists" };
                                            } else {
                                                cardBg = "#ffebee";
                                                borderColor = "#f44336";
                                                statusChip = { color: "#c62828", bg: "#f44336", icon: <ErrorIcon sx={{ fontSize: 14 }} />, label: "Failed" };
                                            }
                                        } else if (isError) {
                                            cardBg = "#ffebee";
                                            borderColor = "#f44336";
                                        }

                                        return (
                                            <Card
                                                key={r.id}
                                                elevation={isError ? 4 : 2}
                                                sx={{
                                                    borderRadius: { xs: 2, sm: 2.5, md: 3 },
                                                    bgcolor: cardBg,
                                                    border: `2px solid ${borderColor}`,
                                                    position: "relative",
                                                    overflow: "visible",
                                                    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                                                    opacity: isFading ? 0 : 1,
                                                    transform: isFading ? "translateY(-20px) scale(0.95)" : "translateY(0)",
                                                    height: isFading ? 0 : "auto",
                                                    marginBottom: isFading ? "-10px" : { xs: 1, sm: 2 },
                                                    padding: isFading ? 0 : { xs: 1, sm: 1.5 },
                                                    "&:hover": {
                                                        boxShadow: isError ? "0 12px 28px rgba(244, 67, 54, 0.15)" : "0 12px 28px rgba(25, 118, 210, 0.15)",
                                                    }
                                                }}
                                            >
                                                {statusChip && !isFading && (
                                                    <Box
                                                        sx={{
                                                            position: "absolute",
                                                            bottom: 8,
                                                            right: 12,
                                                            bgcolor: statusChip.bg,
                                                            color: statusChip.bg === '#ffb300' ? '#000' : 'white',
                                                            px: 1.25,
                                                            py: 0.4,
                                                            borderRadius: 1.5,
                                                            fontSize: { xs: "0.7rem", sm: "0.8rem" },
                                                            fontWeight: 700,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: 0.5,
                                                            zIndex: 1,
                                                            boxShadow: `0 2px 8px ${alpha(statusChip.bg, 0.3)}`
                                                        }}
                                                    >
                                                        {statusChip.icon}
                                                        {statusChip.label}
                                                    </Box>
                                                )}

                                                <CardContent sx={{ pt: { xs: 2, sm: 2.5 }, pb: statusChip ? { xs: 4, sm: 5 } : { xs: 1.5, sm: 2 }, px: { xs: 1.5, sm: 2.5 } }}>
                                                    {/* Main Header Row */}
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'flex-start',
                                                            gap: { xs: 1.5, sm: 2, md: 4 },
                                                            flexWrap: { xs: "wrap", sm: "nowrap" }
                                                        }}
                                                    >
                                                        {/* Company Info */}
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1.5, sm: 2.5 }, flex: { xs: "0 0 100%", sm: 1 } }}>
                                                            <Box
                                                                sx={{
                                                                    background: statusInfo?.status === 201 ? "linear-gradient(135deg, #4caf50, #66bb6a)" : (isError ? "linear-gradient(135deg, #f44336, #ef5350)" : "linear-gradient(135deg, #1976d2, #42a5f5)"),
                                                                    color: "white",
                                                                    width: { xs: 40, sm: 48 },
                                                                    height: { xs: 40, sm: 48 },
                                                                    borderRadius: 2,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    fontWeight: 700,
                                                                    flexShrink: 0,
                                                                    fontSize: { xs: "1.1rem", sm: "1.3rem" },
                                                                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)"
                                                                }}
                                                            >
                                                                {r.CompanyName?.[0]?.toUpperCase() || "?"}
                                                            </Box>
                                                            <Box sx={{ minWidth: 0, flex: 1 }}>
                                                                <Typography
                                                                    variant="h6"
                                                                    fontWeight={700}
                                                                    noWrap
                                                                    sx={{ fontSize: { xs: "1rem", sm: "1.1rem", md: "1.3rem" }, letterSpacing: "-0.3px" }}
                                                                >
                                                                    {r.CompanyName || "Unnamed"}
                                                                </Typography>
                                                                <Typography
                                                                    variant="body2"
                                                                    color="text.secondary"
                                                                    noWrap
                                                                    sx={{ fontSize: { xs: "0.75rem", sm: "0.9rem" }, mt: 0.25 }}
                                                                >
                                                                    {r.ContactPerson || "—"} • {r.MobileNo || "—"}
                                                                </Typography>
                                                            </Box>
                                                        </Box>

                                                        {/* Quick Info - Responsive Grid */}
                                                        <Box
                                                            sx={{
                                                                display: 'grid',
                                                                gridTemplateColumns: { xs: "1fr 1fr", sm: "repeat(4, 1fr)" },
                                                                gap: { xs: 1.25, sm: 1.75 },
                                                                alignItems: 'flex-start',
                                                                flex: { xs: "0 0 100%", sm: "auto" },
                                                                width: { xs: "100%", sm: "auto" }
                                                            }}
                                                        >
                                                            {[
                                                                { label: "GST No.", value: r.GSTNo || "—", key: "GSTNo", icon: "🏛️" },
                                                                { label: "Email", value: r.EmailId || "—", key: "EmailId", icon: "✉️" },
                                                                { label: "Sub Group", value: r.SubGrpName || "—", key: "SubGrpName", icon: "📂" },
                                                                { label: "Location", value: `${r.City || ""}, ${r.State || ""}`.trim() || "—", key: "City", icon: "📍" }
                                                            ].map((item, i) => {
                                                                const hasErr = hasFieldError(r, item.key);
                                                                return (
                                                                    <Box
                                                                        key={i}
                                                                        sx={{
                                                                            bgcolor: hasErr ? alpha('#f44336', 0.08) : alpha('#1976d2', 0.04),
                                                                            borderRadius: 1.5,
                                                                            p: 1,
                                                                            transition: 'all 0.2s ease',
                                                                            display: 'flex',
                                                                            flexDirection: 'column',
                                                                            alignItems: 'flex-start',
                                                                            minWidth: 0,
                                                                            border: `1px solid ${hasErr ? alpha('#f44336', 0.2) : alpha('#1976d2', 0.1)}`
                                                                        }}
                                                                    >
                                                                        <Typography
                                                                            variant="caption"
                                                                            sx={{
                                                                                fontWeight: 700,
                                                                                color: hasErr ? '#f44336' : 'text.secondary',
                                                                                lineHeight: 1.3,
                                                                                fontSize: { xs: "0.7rem", sm: "0.8rem" },
                                                                                textTransform: "uppercase",
                                                                                letterSpacing: "0.5px"
                                                                            }}
                                                                        >
                                                                            {item.label}
                                                                        </Typography>
                                                                        <Typography
                                                                            variant="body2"
                                                                            fontWeight={600}
                                                                            noWrap
                                                                            sx={{
                                                                                mt: 0.4,
                                                                                wordBreak: 'break-word',
                                                                                maxWidth: '100%',
                                                                                fontSize: { xs: "0.75rem", sm: "0.9rem" },
                                                                                color: "#000"
                                                                            }}
                                                                        >
                                                                            {item.value}
                                                                        </Typography>
                                                                    </Box>
                                                                );
                                                            })}
                                                        </Box>

                                                        {/* Expand Button */}
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => toggleExpand(r.id)}
                                                            sx={{
                                                                alignSelf: 'flex-start',
                                                                flexShrink: 0,
                                                                bgcolor: alpha('#1976d2', 0.1),
                                                                color: '#1976d2',
                                                                transition: 'all 0.3s ease',
                                                                "&:hover": {
                                                                    bgcolor: alpha('#1976d2', 0.2),
                                                                    transform: 'scale(1.1)'
                                                                }
                                                            }}
                                                        >
                                                            {expanded ? <ExpandLessIcon sx={{ fontSize: { xs: 20, sm: 24 } }} /> : <ExpandMoreIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />}
                                                        </IconButton>
                                                    </Box>

                                                    {/* Expanded Details */}
                                                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                                                        <Divider sx={{ my: 1.5 }} />
                                                        <Box mt={1.5}>
                                                            {fieldGroups.map((group, gIdx) => (
                                                                <Box key={gIdx} mb={2}>
                                                                    <Typography
                                                                        variant="subtitle2"
                                                                        color="primary"
                                                                        gutterBottom
                                                                        sx={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            gap: 0.75,
                                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                                            fontWeight: 700,
                                                                            textTransform: "uppercase",
                                                                            letterSpacing: "0.5px"
                                                                        }}
                                                                    >
                                                                        {group.icon} {group.title}
                                                                    </Typography>
                                                                    <Grid container spacing={{ xs: 1, sm: 1.5 }}>
                                                                        {group.fields.map((f, fIdx) => (
                                                                            <Grid item xs={12} sm={6} key={fIdx}>
                                                                                <Box sx={{ p: 1, borderRadius: 1.5, bgcolor: alpha('#1976d2', 0.02), border: `1px solid ${alpha('#1976d2', 0.1)}` }}>
                                                                                    <Typography
                                                                                        variant="caption"
                                                                                        sx={{
                                                                                            color: hasFieldError(r, f.key) ? '#f44336' : 'text.secondary',
                                                                                            fontWeight: hasFieldError(r, f.key) ? 700 : 600,
                                                                                            fontSize: { xs: "0.7rem", sm: "0.8rem" },
                                                                                            textTransform: "uppercase",
                                                                                            letterSpacing: "0.3px"
                                                                                        }}
                                                                                    >
                                                                                        {f.label}
                                                                                    </Typography>
                                                                                    <Typography
                                                                                        variant="body2"
                                                                                        fontWeight={600}
                                                                                        sx={{ fontSize: { xs: "0.8rem", sm: "0.9rem" }, mt: 0.5 }}
                                                                                    >
                                                                                        {r[f.key] || "—"}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Grid>
                                                                        ))}
                                                                    </Grid>
                                                                </Box>
                                                            ))}
                                                        </Box>
                                                    </Collapse>
                                                </CardContent>
                                            </Card>
                                        );
                                    })
                                )}
                            </Stack>
                        </Box>
                    </GlassParentCard>
                )}
            </Box>

            {/* Snackbar */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    onClose={() => setSnackbar({ ...snackbar, open: false })}
                    severity={snackbar.severity}
                    sx={{
                        width: "100%",
                        fontSize: { xs: "0.85rem", sm: "0.95rem" },
                        fontWeight: 600,
                        boxShadow: "0 4px 16px rgba(0, 0, 0, 0.15)"
                    }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default InsertClient;